import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Customer } from '../../interfaces/customer/customer';
import { Customersearch } from '../../interfaces/customer/customersearch';
import { Geozone } from '../../interfaces/zones/geozone';
import { JobAddress } from '../../interfaces/job-address/job-address';
import { JobAddressInfo } from '../../interfaces/job-address/job-address-info';
import { Lead } from '../../interfaces/lead/lead';
import { LeadSource } from '../../interfaces/lead/lead-source';
import { LeadSubSource } from '../../interfaces/lead/lead-sub-source';
import { LeadType } from '../../interfaces/lead/lead-type';
import { SmartSchedulerResponse } from '../../interfaces/smart-scheduler/smart-scheduler-response';
import { Availability } from '../../interfaces/smart-scheduler/availability';
import { Appointment } from '../../interfaces/appointment/appointment';
import { SalesCalendarEvent } from '../../interfaces/calendar/sales-calendar-data';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { EstimatorAvailability } from '../../interfaces/estimator-availability';
import { User } from '../../interfaces/auth/user';
import { GeoZoneFull } from '../../interfaces/zones/geo-zone-full';
import { Role } from '../../interfaces/role';
import { Estimator } from '../../interfaces/calendar/estimator';
import { Note } from '../../interfaces/notes/note';
import { ProductSubCategory } from '../../interfaces/products/product-sub-category';
import { Proposal } from '../../interfaces/proposal/proposal';
import { FullJobAddressInfo } from '../../interfaces/job-address/full-job-address-info';
import { CustomerVisit } from '../../interfaces/customer-visit';
import { Statement } from '../../interfaces/proposal/statement';
import { NoBidReason } from '../../interfaces/customer-visit/no-bid-reason';
import { AllStatusCounts } from '../../interfaces/status-counts/all-status-counts';
import { Status } from '../../interfaces/status';
import { Attachment } from '../../interfaces/attachments/attachment';
import { VehicleDocumentationAttachment } from '../../interfaces/attachments/vehicle-documentation-attachment';
import { environment } from 'src/environments/environment';
import { ProductionCounts } from '../../interfaces/status-counts/production-counts';
import { CclCounts } from '../../interfaces/status-counts/ccl-counts';
import { PermitCounts } from '../../interfaces/status-counts/permit-counts';
import { Contract } from '../../interfaces/sales-management/contract';
import { FollowUp } from '../../interfaces/customer-visit/follow-up';
import { Project } from '../../interfaces/production/project';
import { ProdAvailability } from '../../interfaces/production/prod-availability';
import { ProdAppointment } from '../../interfaces/production/prod-appointment';
import { Zone } from '../../interfaces/zones/zone';
import { Production } from '../../interfaces/production/production';
import { ChangeOrder } from '../../interfaces/production/change-order';
import { Upsell } from '../../interfaces/production/upsell';
import { ServiceAvailability } from '../../interfaces/service/service-availability';
import { ServiceAppointment } from '../../interfaces/service/service-appointment';
import { ServiceProject } from '../../interfaces/service/service-project';
import { AccountingInfo } from '../../interfaces/invoice/accounting-info';
import { ServiceVisit } from '../../interfaces/service/service-visit';
import { GeneratedContract } from '../../interfaces/contract/generated-contract';
import { WrapUp } from '../../interfaces/wrap-up';
import { PWAModel } from '../../interfaces/offline/pwa';
import { Statements } from '../../interfaces/offline/statements';
import { LastEstimator } from '../../interfaces/smart-scheduler/last-estimator';
import { SoldSheet } from '../../interfaces/customer-visit/sold-sheet';
import { UpsellContract } from '../../interfaces/upsell/upsell-contract';
import { GeneratedUpsellContract } from '../../interfaces/upsell/generated-upsell-contract';
import { Product } from '../../interfaces/proposal/product';
import { ChangeOrderContract } from '../../interfaces/production/change-order-contract';
import { GeneratedChangeOrderContract } from '../../interfaces/production/generated-change-order-contract';
import { Permit } from '../../interfaces/permits/permit';
import { Utility } from '../../interfaces/utilities/utility';
import { CalendarNote } from '../../interfaces/calendar/calendar-note';
import { LeadsByDateReport } from '../../interfaces/reports/leads-by-date-report';
import { LeadsByDateReportParameters } from '../../interfaces/reports/leads-by-date-report-parameters';
import { ReportPermissions } from '../../interfaces/reports/report-permissions';
import { ReportInfo } from '../../interfaces/reports/report-info';
import { CCLContact } from '../../interfaces/ccl/ccl-contact';
import { CCLContactProject } from '../../interfaces/ccl/ccl-contact-project';
import { BOMReport } from '../../interfaces/reports/bom-report';
import { ClosingPercentageReport } from '../../interfaces/reports/closing-percentage-report';
import { WeeklyLeadsKPI } from '../../interfaces/reports/weekly-leads-report';
import { WeeklyCallCenterKPI } from '../../interfaces/reports/weekly-call-center-kpi';
import { Invoice } from '../../interfaces/production/invoice';
import { IVPDDetailReport } from '../../interfaces/reports/ivpd-detail-report';
import { IVPDGroupedReport } from '../../interfaces/reports/ivpd-grouped-report';
import { IVPDReportParameters } from '../../interfaces/reports/ivpd-report-parameters';
import { VariableConfig } from '../../interfaces/misc/variable-config';
import { ContactMethod } from '../../interfaces/customer/contact-method';
import { Disposition } from '../../interfaces/customer-visit/disposition';
import { SubDisposition } from '../../interfaces/customer-visit/sub-disposition';
import { MarkedAsSoldReport } from '../../interfaces/reports/marked-as-sold-report';
import { ApprovedJobsReport } from '../../interfaces/reports/approved-jobs-report';
import { ProjectClosingPercentageReportParameters } from '../../interfaces/reports/project-closing-percentage-report-parameters';
import { ProjectClosingPercentageReport } from '../../interfaces/reports/project-closing-percentage-report';
import { SpectrumInfo } from '../../interfaces/invoice/spectrum-info';
import { Foreman } from '../../interfaces/zones/foreman';
import { MailingRequest } from '../../interfaces/customer/mailing-requests';
import { MailingRequestDocuments } from '../../interfaces/customer/mailing-request-documents';
import { Drawing } from '../../interfaces/drawing-program/drawing';
import { NoteFunctionOptions } from '../../interfaces/notes/note-function-options';
import { ExistingJobAddress } from '../../interfaces/job-address/existing-job-address';
import { SalesOverviewReport } from '../../interfaces/reports/sales-overview-report';
import { SalesOverviewDetailReport } from '../../interfaces/reports/sales-overview-detail-report';
import { EstimatorPriority } from '../../interfaces/smart-scheduler/estimator-priority';
import { BiddingPercentageReport } from '../../interfaces/reports/bidding-percentage-report';
import { SpectrumCrewMember } from '../../interfaces/dailies/spectrum-crew-member';
import { SpectrumMaterial } from '../../interfaces/dailies/spectrum-material';
import { ProdDaily } from '../../interfaces/dailies/prod-daily';
import { Crew } from '../../interfaces/dailies/crew';
import { TimeLog } from '../../interfaces/dailies/time-log';
import { TimeBreakDown } from '../../interfaces/dailies/time-breakdown';
import { DailyMaterial } from '../../interfaces/dailies/daily-material';
import { DailyPaymentInfo } from '../../interfaces/dailies/daily-payment-info';
import { DailyPrompt } from '../../interfaces/dailies/daily-prompt';
import { BillingStatement } from '../../interfaces/production/billing-statement';
import { GeneratedInvoice } from '../../interfaces/production/generated-invoice';
import { Zipcode } from '../../interfaces/zones/zipcode';
import { CommissionInfo } from '../../interfaces/sales-management/commission-info';
import { CommissionExceptions } from '../../interfaces/sales-management/commission-exception';
import { CommissionExceptionReason } from '../../interfaces/sales-management/commission-exception-reason';
import { OfflineUserSyncDownLog } from '../../interfaces/offline/offline-user-sync-down-log';
import { SpectrumEmployees } from '../../interfaces/spectrum/spectrum-employees';
import { ProductPricing } from '../../interfaces/proposal/product-pricing';
import { CustomerSearchResults } from '../../interfaces/customer/customer-search-results';
import { BOMReportParameters } from '../../interfaces/reports/bom-report-parameters';
import { ClosingPercentageReportParameters } from '../../interfaces/reports/closing-percentage-report-parameters';
import { GeocodingResponse } from '../../interfaces/google-maps/geocoding-response';
import { TimeZoneResponse } from '../../interfaces/google-maps/time-zone-response';
import { ServiceAppointmentsCreatedReport } from '../../interfaces/reports/service-appointments-created-report';
import { AppointmentsCreatedReport } from '../../interfaces/reports/appointments-created-report';
import { DoNotCall } from '../../interfaces/customer/do-not-call';
import { UnlockedCommission } from '../../interfaces/sales-management/unlocked-commission';
import { CommissionOlogReport } from '../../interfaces/reports/commission-olog-report';
import { CommissionPaymentsByPayrollWeekReport } from '../../interfaces/reports/commission-payments-by-payroll-week-report';
import { CommissionRecalculateResult } from '../../interfaces/sales-management/commission-recalculate-result';
import { MarkedAsSoldReportParameters } from '../../interfaces/reports/marked-as-sold-parameters';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  apiUrl = environment.apiUrl;
  // Gets
  getServerStatusUrl = this.apiUrl + 'ServerStatus';
  getCustomersUrl = this.apiUrl + 'customers';
  getCustomerByIdUrl = this.apiUrl + 'Custid';
  searchCustomerUrl =
    this.apiUrl +
    'search/customer/%7Bjobaddress,lastname,phoneNumber,customerId,projectId%7D?';
  leadSourcesUrl = this.apiUrl + 'lead/leadsource';
  leadSubSourcesUrl =
    this.apiUrl + 'Lead/LeadSource/SubSource/%7Bcompany_code,leadSourceId%7D?';
  getLeadUrl = this.apiUrl + 'Lead';
  getLeadTypesUrl = this.apiUrl + 'lead/leadtype/';
  getGeoZoneByZipUrl = this.apiUrl + 'GeoZones/%7Bcompany_code,zipcode%7D?';
  getJobAddressInfoUrl =
    this.apiUrl + 'JobAddress/Info/%7Bjobaddressid,customerid%7D?';

  getSmartSchedulerDataUrl =
    this.apiUrl +
    'SmartScheduler/%7BuserName,geoZone,leadType,jobAddress,company_code,jobAddressId,leadId,selectedEstimators%7D?';
  getEstimatorsForSmartSchedulerUrl =
    this.apiUrl +
    'ProcessAvailablity/%7Bcompany_code,geoZoneId,leadType,leadSourceId%7D?';
  getProcesssedAvailabilityUrl = this.apiUrl + 'ResetFilter/';
  getSalesCalendarUrl = this.apiUrl + 'SalesCalendar/%7Bemployeeid,date%20%7D?';
  getUserDataUrl = this.apiUrl + 'users/%7BUserId,Name%7D?';
  getEstimatorAvailabilityUrl = this.apiUrl + 'estavailskill';
  getRolesUrl = this.apiUrl + 'user/Roles/%7BCompany_Code,Desc%7D?';
  getAllGeoZonesUrl = this.apiUrl + 'GeoZones/All';
  getEstimatorsUrl = this.apiUrl + 'Sales/Estimators';
  getAppointmentUrl = this.apiUrl + 'Appointment';
  getAllProductsUrl = this.apiUrl + 'products/Get';
  getAllJobAddressInfoUrl = this.apiUrl + 'CustomerDetails';
  getCustomerVisitUrl = this.apiUrl + 'CustomerVisit/GetbyId';
  getProposalDetailsUrl = this.apiUrl + 'Proposal/GetDetails';
  getStatementsUrl =
    this.apiUrl + 'Proposal/GetStatements/%7Bcompany_code,proposalid%7D?';
  getNoBidReasonsUrl = this.apiUrl + 'Status/NoBidReason';
  getProposalIdsByCustomerVisitIdUrl =
    this.apiUrl +
    'CustomerVisit/GetProposalDetail/%7Bcompany_code,customervisitId%7D?';
  getStatusesBySectionUrl =
    this.apiUrl + 'Section/Statuses/%7Bcompany_code,SectionName%7D?';
  getUsersByRoleUrl = this.apiUrl + 'SalesManagement/SalesApproval/WhoSold';
  getCustomerVisitFollowUpUrl =
    this.apiUrl + 'CustomerVisit/FollowUp/%7Bcompany_code,customervisitId%7D?';
  getProductionScheduleUrl =
    this.apiUrl + 'ProductionScheduling/Get/%7Bwdate,mdate,userId%7D?';
  getProjectByIdUrl = this.apiUrl + 'Project/GetProjectbyId';
  getForemanByProjectTypeAndGeoZoneUrl =
    this.apiUrl +
    'ProductionScheduling/Get/GetForemanbyPTandGeo/%7BprojectTypeid,geozoneid%7D?';
  getAllZonesUrl = this.apiUrl + 'Zones/All';
  getForemanByZoneUrl =
    this.apiUrl +
    'ProductionScheduling/Get/GetForemanbyZone/%7Bzoneid,date%7D?';
  getProductionUrl =
    this.apiUrl + 'Production/GetbyId/%7Bcompany_code,productionId%7D?';
  getProductionByProdSchedIdUrl =
    this.apiUrl +
    'ProductionScheduling/Get/ProductionbyId/%7B company_code,prodschedId%7D?';
  getProdApptByProdSchedIdUrl =
    this.apiUrl + 'ProductionScheduling/Get/ProductionApptbyId';
  getServiceAvailabilityUrl =
    this.apiUrl + 'ServiceScheduling/Get/%7Bwdate,mdate,userId%7D?';
  getServiceByProjectTypeAndGeoZoneUrl =
    this.apiUrl + 'ServiceScheduling/GetTechs/%7BprojectTypeid,geozoneid%7D?';
  getProjectsByJobAddressUrl = this.apiUrl + 'Service/GetProjectsbyJobAddress';
  getAccountingInfoByProjectIdUrl =
    this.apiUrl + 'AccountingInfo/Get/ByProjectId';
  getServiceProjectByIdUrl = this.apiUrl + 'ServiceScheduling/project/byId';
  getServiceTechByZoneUrl = this.apiUrl + 'ServiceScheduling/GetTechs/byZone';
  getServiceApptByIdUrl = this.apiUrl + 'ServiceScheduling/Appointment/byId';
  getServiceVisitByServiceApptIdUrl =
    this.apiUrl +
    'ServiceVisit/Appointment/GetbyId/%7Bcompany_code,serviceAppointmentId%7D?';
  getNotesByJobAddressUrl = this.apiUrl + 'Notes/Get/ByJobAddress';
  getCustomerNotesUrl = this.apiUrl + 'Notes/Get/ByCustomer';
  getNotesByFunctionUrl =
    this.apiUrl + 'Notes/Get/ByFunction/%7Bfunctionid,functionname%7D?';
  getProductionByProjectIdUrl = this.apiUrl + 'Production/GetbyProjectId';
  getProductionByContractIdUrl = this.apiUrl + 'Production/GetbyContractId';
  // getPWADataUrl = this.apiUrl + 'PWA/Get/SalesInfo/%7Bcompany_code,userid%7D?';
  getLastEstimatorUrl =
    this.apiUrl + 'Appointment/lastEstimator/%7Bcompany_code,jobaddressId%7D?';
  getSoldSheetUrl = this.apiUrl + 'SalesManagement/SalesApproval/soldSheet';
  getUpsellByIdUrl = this.apiUrl + 'Upsell/GetById';
  getServiceVisitByServiceProjectIdUrl =
    this.apiUrl + 'ServiceVisit/GetByServiceProjectId';
  getUpsellProductsUrl =
    this.apiUrl + 'Products/GetUpsell/%7BuserId,functionName%7D?';
  getProposalsByAppointmentIdUrl = this.apiUrl + 'Proposal/GetByAppointmentId';
  getPendingDeadLeadUrl = this.apiUrl + 'Lead/GetPendingDeadLead';
  getPendingChangeOrdersUrl = this.apiUrl + 'ChangeOrder/Get/Pending';
  getAllDispositionsUrl =
    this.apiUrl + 'Dispositions/Get/AllDispositions/%7BuserId,functionName%7D?';
  getAllSubDispositionsUrl =
    this.apiUrl +
    'Dispositions/Get/AllSubDispositions/%7BuserId,functionName%7D?';
  getAllNoBidReasonsUrl =
    this.apiUrl + 'Dispositions/Get/AllNoBidReasons/%7BuserId,functionName%7D?';
  getAppointmentsByJobAddressIdUrl =
    this.apiUrl + 'Appointment/Get/ByJobAddressId';
  getProdAppointmentsByJobAddressIdUrl =
    this.apiUrl + 'Production/Appointment/Get/ByJobAddressId';
  getServiceAppointmentsByJobAddressIdUrl =
    this.apiUrl + 'Service/Appointment/Get/ByJobAddressId';
  getAllFollowUpsUrl =
    this.apiUrl + 'FollowUp/GetAll/%7Bcompany_code,userId%7D?';
  getServiceProjectsByJobAddressIdUrl =
    this.apiUrl + 'Service/GetServiceProjectsByJobAddressId';
  getNotesByFunctionNameUrl =
    this.apiUrl + 'Notes/Get/ByFunctionName/%7BjobAddressId,functionName%7D?';
  getAppointmentsByLeadIdUrl = this.apiUrl + 'Appointment/Get/ByLeadId';

  // Get Counts by Status
  getAllStatusCountsUrl = this.apiUrl + 'Counts/Statuses';
  getLeadsByStatusUrl = this.apiUrl + 'lead/status';
  getAppointmentsByStatusUrl =
    this.apiUrl + 'Appointment/byStatus/%7Bcompany_code,status%7D?';
  getCustomerVisitsByStatusUrl =
    this.apiUrl + 'CustomerVisit/byStatus/%7Bcompany_code,status%7D?';
  getProposalByStatusUrl =
    this.apiUrl + 'Proposal/byStatus/%7Bcompany_code,status%7D?';
  getSalesManagementByStatusUrl =
    this.apiUrl + 'SalesManagement/byStatus/%7Bcompany_code,status%7D?';
  getProductionSchedulingByStatusUrl =
    this.apiUrl + 'ProductionScheduling/byStatus/%7Bcompany_code,status%7D?';
  getProductionManagementByStatusUrl =
    this.apiUrl + 'ProductionManagement/byStatus/%7Bcompany_code,status%7D?';
  getServiceProjectsByStatusUrl =
    this.apiUrl + 'Service/byStatus/%7Bcompany_code,status%7D?';
  getServiceManagementByStatusUrl =
    this.apiUrl + 'ServiceManagement/byStatus/%7Bcompany_code,status%7D?';
  getDigsByStatusUrl = this.apiUrl + 'Digs/byStatus/%7Bcompany_code,status%7D?';
  getPermitsByStatusUrl =
    this.apiUrl + 'Permits/byStatus/%7Bcompany_code,status%7D?';
  getUtilitiesByStatusUrl =
    this.apiUrl + 'Utilities/byStatus/%7Bcompany_code,status%7D?';
  getProjectsByStatusUrl =
    this.apiUrl + 'Project/Get/byStatus/%7Bcompany_code,status%7D?';
  getServiceVisitByIdUrl = this.apiUrl + 'ServiceVisit/GetbyId';
  getGeneratedContractUrl = this.apiUrl + 'Contracts/getGeneratedContract';
  getProductionWrapUpUrl =
    this.apiUrl + 'Production/Get/WrapUp/%7BfunctionId,functionName%7D?';
  getServiceWrapUpUrl =
    this.apiUrl + 'ServiceVisit/Get/WrapUp/%7BfunctionId,functionName%7D?';
  getChangeOrderByIdUrl =
    this.apiUrl + 'ChangeOrder/Get/%7Bcompany_code,changeOrderId%7D?';
  getChangeOrdersByProjectIdUrl = this.apiUrl + 'ChangeOrder/GetByProjectId';
  getPermitByIdUrl =
    this.apiUrl + '/Permits/Get/ById/%7Bcompany_code,permitId%7D?';
  getPermitsByProjectIdUrl = this.apiUrl + 'Permits/Get/ByProjectId';
  getUtilitiesByProjectIdUrl = this.apiUrl + 'Utility/Get/ByProjectId';
  getSoldSheetByProposalIdUrl =
    this.apiUrl + 'SalesManagement/Get/SoldSheetByProposalId';
  getSalesCalendarEventByAppointmentIdUrl =
    this.apiUrl + 'SalesCalendarEvent/Get/%7Bcompany_code,appointmentId%7D?';
  getContractByProposalIdUrl = this.apiUrl + 'Contracts/GetByProposalId';
  getCalendarNotesByUserIdUrl =
    this.apiUrl + 'CalendarNotes/Get/ByUserId/%7BuserId,date%7D?';
  getCalendarNotesByNoteTypeUrl =
    this.apiUrl + 'CalendarNotes/Get/ByNoteType/%7BnoteType,date%7D?';
  getGeneratedChangeOrderContractUrl =
    this.apiUrl + 'GeneratedChangeOrderContract/GetByChangeOrderId';
  getJobAddressByIdUrl = this.apiUrl + 'JobAddress/GetById';
  getJobAddressesByCustomerIdUrl = this.apiUrl + 'JobAddress/GetByCustomerId';
  getNeedsFirstContactUrl =
    this.apiUrl + 'CCL/NeedsFirstContact/%7Bcompany_code,status%7D?';
  getCCLContactByStatusUrl =
    this.apiUrl + 'CCL/byStatus/%7Bcompany_code,status%7D?';
  checkForCCLContactUrl =
    this.apiUrl + 'CCL/CheckForCCLContact/%7Bcompany_code,projectId%7D?';
  getCCLContactProjectsUrl =
    this.apiUrl + 'CCL/GetCCLContactProjects/%7Bcompany_code,jobAddressId%7D?';
  getGeneratedUpsellContractUrl =
    this.apiUrl + 'Contracts/GetGeneratedUpsellContract';
  getVariableConfigUrl = this.apiUrl + 'VariableConfig/Get';
  getContactMethodsByCustomerIdUrl =
    this.apiUrl + 'Customer/Get/AllContactMethods';
  getCustomerVisitByIdUrl = this.apiUrl + 'CustomerVisit/GetById';
  getCustomerVisitsByJobAddressIdUrl =
    this.apiUrl + 'CustomerVisit/GetByJobAddressId';
  getProposalsByCustomerVisitIdUrl =
    this.apiUrl + 'Proposal/GetByCustomerVisitId';
  getCustomerVisitByAppointmentIdUrl =
    this.apiUrl + 'CustomerVisit/GetByAppointmentId';
  getSpectrumInfoUrl =
    this.apiUrl + 'SpectrumInfo/%7Bcompany_code,projectId%7D?';
  getCustomerVisitsSentToInsideSalesUrl =
    this.apiUrl + 'CustomerVisit/GetSentToInsideSales';
  getForemanZonesUrl = this.apiUrl + 'User/Foreman/Zones/Get';
  getMailingRequestsByJobAddressIdUrl =
    this.apiUrl + 'Customer/Get/MailingRequests/ByJobAddressId';
  getMailingRequestsCountUrl = this.apiUrl + 'Counts/MailingRequests';
  getOpenMailingRequestsUrl = this.apiUrl + 'Customer/Get/OpenMailingRequests';
  getMailingRequestDocumentsByFunctionUrl =
    this.apiUrl +
    'Customer/Get/MailingRequests/DocumentsByFunction/%7BjobAddressId,functionId,functionName%7D?';
  getDrawingsByJobAddressIdUrl = this.apiUrl + 'Drawings/GetByJobAddressId';
  getNoteFunctionOptionsByJobAddressIdUrl =
    this.apiUrl + 'Notes/Get/FunctionOptions/ByJobAddressId';
  checkForExistingJobAddressUrl =
    this.apiUrl + 'JobAddress/Check/%7BjobAddress,jobZip%7D?';
  getServiceAppointmentsByServiceProjectIdUrl =
    this.apiUrl + 'Service/Appointments/Get/ByServiceProjectId';
  getEstimatorPriorityUrl = this.apiUrl + 'EstimatorPriority/Get';
  getAllSpectrumCrewMembersUrl = this.apiUrl + 'ProdDailies/CrewMembers/GetAll';
  getAllSpectrumMaterialsUrl = this.apiUrl + 'ProdDailies/Materials/GetAll';
  getProductionByIdUrl =
    this.apiUrl + 'ProductionManagement/GetProduction/ById';
  getProdDailiesByProductionIdUrl =
    this.apiUrl +
    'ProductionManagement/GetProdDailies/ByProductionId/%7Bcompany_code,productionId%7D?';
  getProdDailiesByJobAddressIdUrl =
    this.apiUrl +
    'ProductionManagement/GetProdDailies/ByJobAddressId/%7Bcompany_code,jobAddressId%7D?';
  getProdDailiesByContractIdUrl =
    this.apiUrl + 'ProductionManagement/GetProdDailies/ByContractId';
  getContractByIdUrl = this.apiUrl + 'Contracts/Get/ById';
  getChangeOrdersByFunctionIdUrl =
    this.apiUrl + 'ChangeOrder/Get/ByFunctionId/%7Bcompany_code,functionId%7D?';
  getChangeOrdersByJobAddressIdUrl =
    this.apiUrl +
    'ChangeOrder/Get/ByJobAddressId/%7Bcompany_code,jobAddressId%7D?';
  getUpsellsByFunctionIdUrl =
    this.apiUrl + 'Upsell/Get/ByFunctionId/%7Bcompany_code,functionId%7D?';
  getProjectsByContractIdUrl =
    this.apiUrl + 'Project/Get/ByContractId/%7Bcompany_code,contractId%7D?';
  getInvoiceByProjectIdUrl =
    this.apiUrl +
    'Invoicing/Get/Invoice/ByProjectId/%7Bcompany_code,projectId%7D?';
  getInvoicesByFunctionIdUrl =
    this.apiUrl + 'Invoicing/Get/Invoices/ByFunctionId';
  getBillingStatementsByFunctionIdUrl =
    this.apiUrl +
    'Invoicing/Get/BillingStatements/ByFunctionId/%7Bcompany_code,functionId%7D?';
  getDailyPaymentInfoByProductionIdUrl =
    this.apiUrl +
    'Invoicing/Get/DailyPaymentInfo/ByProductionId/%7Bcompany_code,productionId%7D?';
  getDailyPromptsByProductionIdUrl =
    this.apiUrl +
    'ProdDailies/DailyPrompts/Get/ByProductionId/%7Bcompany_code,productionId%7D?';
  getGeneratedInvoiceByInvoiceNumberUrl =
    this.apiUrl + 'ProductionManagement/Get/GeneratedInvoice/ByInvoiceNumber';
  getDailyMaterialsByProductionIdUrl =
    this.apiUrl +
    'ProdDailies/Materials/Get/ByProductionId/%7Bcompany_code,productionId%7D?';
  getCrewByProdDailyIdUrl =
    this.apiUrl +
    'ProdDailies/Crews/Get/ByProdDailyId/%7Bcompany_code,prodDailyId%7D?';
  getTimeLogsByProdDailyIdUrl =
    this.apiUrl +
    'ProdDailies/TimeLogs/Get/ByProdDailyId/%7Bcompany_code,prodDailyId%7D?';
  getTimeBreakDownByProdDailyIdUrl =
    this.apiUrl +
    'ProdDailies/TimeBreakDowns/Get/ByProdDailyId/%7Bcompany_code,prodDailyId%7D?';
  getProjectsForProductionRecordUrl =
    this.apiUrl +
    'ProductionManagement/Get/ProjectsByProduction/%7Bcompany_code,contractId,assignedName,productionCreatedDate%7D?';
  getDailyPromptsByProdDailyIdUrl =
    this.apiUrl +
    'ProductionManagement/Get/DailyPrompts/ByProdDailyId/%7Bcompany_code,prodDailyId%7D?';
  getProductionJobDaysUrl = this.apiUrl + 'ProductionManagement/Get/JobDays';
  getZipcodeUrl = this.apiUrl + 'Get/Zipcode/%7Bcompany_code,zipcode%7D?';
  getJobAddressesByZipcodeUrl =
    this.apiUrl + 'Get/JobAddresses/By/Zipcode/%7Bzipcode%7D?';
  getCommissionInfoByContractIdUrl =
    this.apiUrl +
    'SalesManagement/Get/CommissionInfo/%7Bcompany_code,contractId%7D?';
  getCommissionExceptionReasonsUrl =
    this.apiUrl + 'SalesManagement/Get/CommissionExceptionReasons';
  getUnlockedCommissionsUrl =
    this.apiUrl + 'SalesManagement/Get/UnlockedCommissions';
  getCommissionExceptionByContractIdUrl =
    this.apiUrl +
    'SalesManagement/Get/CommissionException/ByContractId/%7Bcompany_code,contractId%7D?';
  checkIfUserCanReviewCommissionsUrl =
    this.apiUrl +
    'CommissionReview/CheckIfUserCanReviewCommissions/%7Bcompany_code,userId%7D?';
  checkIfUserCanViewCommissionUrl =
    this.apiUrl +
    'CommissionReview/CheckIfUserCanViewCommissions/%7Bcompany_code,userId%7D?';
  recalculateMaxCommissionUrl = this.apiUrl + 'Commission/MaxCommission/%7Bdiscount,estimator,inside,service,foreman%7D?';
  getSpectrumEmployeesUrl = this.apiUrl + 'Admin/Users/Spectrum/Get';
  getProductPricingUrl =
    this.apiUrl + 'ProductPricing/Get/%7Bcompany_code,zoneId%7D?';
  getAllZipCodesByZipUrl = this.apiUrl + 'Get/All/ZipCodes/ByZip';
  getAllCompanyCodesUrl = this.apiUrl + 'CompanyCodes/GetAll';
  getInsideSalesProductsUrl = this.apiUrl + 'InsideSales/Get/Products';
  getInsideSalesStatementsUrl = this.apiUrl + 'InsideSales/Get/Statements';
  getInsideSalesDispositionsUrl = this.apiUrl + 'InsideSales/Get/Dispositions';
  getInsideSalesSubDispositionsUrl =
    this.apiUrl + 'InsideSales/Get/SubDispositions';
  getInsideSalesNoBidReasonsUrl = this.apiUrl + 'InsideSales/Get/NoBidReasons';
  getEstimatorCompanyCodesUrl =
    this.apiUrl + 'Admin/Get/Estimator/CompanyCodes';
  getEstimatorPriorityByUserIdUrl =
    this.apiUrl + 'Admin/Get/Estimator/Priorities';
  checkUserRoleByEmailUrl = this.apiUrl + 'Email/CheckUserRole';
  getDoNotCallByCustomerIdUrl = this.apiUrl + 'Customer/Get/DoNotCall';

  // Labeled PWA but is not PWA
  getProdApptsByProjectIdUrl =
    this.apiUrl + 'PWA/Get/Production/ProductionAppointmentsbyProjectId';
  getProductionWrapUpByProjectIdUrl =
    this.apiUrl +
    'PWA/Get/Service/ProductionWrapupbyProjectId/%7BjobAddressId,projectId%7D?';

  // Get PWA Attachments
  getPWAJobAddressIdsForAttachmentsUrl =
    this.apiUrl + 'PWA/Get/JobAddressIdsForAttachments/%7Buserid,function%7D?';
  getPWAAttachmentsByJobAddressIdUrl =
    this.apiUrl + 'PWA/Get/AttachmentsByJobAddressId';

  // Get Offline Data. Sales
  getPWACustomersUrl = this.apiUrl + 'PWA/Get/Customers/%7Buserid,hotQuote%7D?';
  getPWALeadsUrl = this.apiUrl + 'PWA/Get/Leads/%7Buserid,hotQuote%7D?';
  getPWAJobAddressUrl =
    this.apiUrl + 'PWA/Get/JobAddress/%7Buserid,hotQuote%7D?';
  getPWAAppointmentsUrl =
    this.apiUrl + 'PWA/Get/Appointments/%7Buserid,hotQuote%7D?';
  getPWASalesCalendarUrl =
    this.apiUrl + 'PWA/Get/SalesCalendar/%7Buserid,hotQuote%7D?';
  getPWACustomerVisitsUrl =
    this.apiUrl + 'PWA/Get/CustomerVisits/%7Buserid,hotQuote%7D?';
  getPWAProposalsUrl = this.apiUrl + 'PWA/Get/Proposals/%7Buserid,hotQuote%7D?';
  getPWAProductsUrl =
    this.apiUrl + 'PWA/Get/Products/%7BuserId,functionName%7D?';
  getPWAStatementsUrl =
    this.apiUrl + 'PWA/Get/Statements/%7BuserId,functionName%7D?';
  getPWAContractsUrl = this.apiUrl + 'PWA/Get/Contracts/%7Buserid,hotQuote%7D?';
  getPWAGeneratedContractsUrl =
    this.apiUrl + 'PWA/Get/generatedContracts/%7Buserid,hotQuote%7D?';
  getPWANotesUrl = this.apiUrl + 'PWA/Get/Notes/%7Buserid,hotQuote%7D?';
  getPWASoldSheetsUrl =
    this.apiUrl + 'PWA/Get/SoldSheets/%7Buserid,hotQuote%7D?';
  getPWAAttachmentsUrl = this.apiUrl + 'PWA/Get/Attachments';
  getPWAFollowUpsUrl = this.apiUrl + 'PWA/Get/FollowUps/%7Buserid,hotQuote%7D?';
  getSalesPWAContactMethodsUrl =
    this.apiUrl + 'PWA/Get/Sales/ContactMethods/%7Buserid,hotQuote%7D?';
  // Get Offline Data. Production
  getProdPWACustomersUrl = this.apiUrl + 'PWA/Get/Production/Customers';
  getProdPWAJobAddressUrl = this.apiUrl + 'PWA/Get/Production/JobAddress';
  getProdPWAAppointmentsUrl = this.apiUrl + 'PWA/Get/Production/Appointments';
  getProdPWAAvailabilityUrl =
    this.apiUrl + 'PWA/Get/Production/ProdAvailability';
  getProdPWAGeneratedContractsUrl =
    this.apiUrl + 'PWA/Get/Production/GeneratedContracts';
  getProdPWANotesUrl = this.apiUrl + 'PWA/Get/Production/Notes';
  getProdPWAAttachmentsUrl = this.apiUrl + 'PWA/Get/Production/Attachments';
  getProdPWAProjectsUrl = this.apiUrl + 'PWA/Get/Production/Projects';
  getProdPWAProductionUrl = this.apiUrl + 'PWA/Get/Production/Production';
  // getProdPWAProductsUrl = this.apiUrl + 'PWA/Get/Production/Products';
  // getProdPWAStatementsUrl = this.apiUrl + 'PWA/Get/Production/Statements';
  getProdPWAProposalsUrl = this.apiUrl + 'PWA/Get/Production/Proposals';
  getProdPWAChangeOrdersUrl = this.apiUrl + 'PWA/Get/Production/ChangeOrder';
  getProdPWAAccountingInfoUrl =
    this.apiUrl + 'PWA/Get/Production/AccountingInfo';
  getProdPWAContractsUrl = this.apiUrl + 'PWA/Get/Production/Contracts';
  getProdPWAChangeOrderContractsUrl =
    this.apiUrl + 'PWA/Get/Production/ChangeOrderContract';
  getProdPWAGeneratedChangeOrderContractsUrl =
    this.apiUrl + 'PWA/Get/Production/GeneratedChangeOrderContract';
  getProdPWAInvoicesUrl = this.apiUrl + 'PWA/Get/Production/Invoices';
  getProdPWAContactMethodsUrl =
    this.apiUrl + 'PWA/Get/Production/ContactMethods';
  getProdPWAProdDailiesUrl = this.apiUrl + 'PWA/Get/Production/ProdDailies';
  getProdPWACrewsUrl = this.apiUrl + 'PWA/Get/Production/Crews';
  getProdPWATimeLogsUrl = this.apiUrl + 'PWA/Get/Production/TimeLogs';
  getProdPWATimeBreakDownsUrl =
    this.apiUrl + 'PWA/Get/Production/TimeBreakDowns';
  getProdPWADailyMaterialsUrl =
    this.apiUrl + 'PWA/Get/Production/DailyMaterials';
  getProdPWADailyPaymentInfoUrl =
    this.apiUrl + 'PWA/Get/Production/DailyPaymentInfo';
  getProdPWADailyPromptsUrl = this.apiUrl + 'PWA/Get/Production/DailyPrompts';
  getProdPWAUpsellsUrl = this.apiUrl + 'PWA/Get/Production/Upsells';
  getProdPWAUpsellContractsUrl =
    this.apiUrl + 'PWA/Get/Production/UpsellContracts';
  getProdPWAGeneratedUpsellContractsUrl =
    this.apiUrl + 'PWA/Get/Production/GeneratedUpsellContracts';
  getProdPWAGeneratedInvoicesUrl =
    this.apiUrl + 'PWA/Get/Production/GeneratedInvoices';
  getProdPWABillingStatementsUrl =
    this.apiUrl + 'PWA/Get/Production/BillingStatements';
  getProdPWALeadsUrl = this.apiUrl + 'PWA/Get/Production/Leads';

  // Get Offline Data. Service
  getServicePWACustomersUrl = this.apiUrl + 'PWA/Get/Service/Customers';
  getServicePWAJobAddressUrl = this.apiUrl + 'PWA/Get/Service/JobAddress';
  getServicePWAAppointmentsUrl = this.apiUrl + 'PWA/Get/Service/Appointments';
  getServicePWAAvailabilityUrl =
    this.apiUrl + 'PWA/Get/Service/ServAvailability';
  // getServicePWAProductsUrl = this.apiUrl + 'PWA/Get/Service/Products';
  // getServicePWAStatementsUrl = this.apiUrl + 'PWA/Get/Service/Statements';
  getServicePWAGeneratedContractsUrl =
    this.apiUrl + 'PWA/Get/Service/GeneratedContracts';
  getServicePWAServiceProjectsUrl =
    this.apiUrl + 'PWA/Get/Service/ServiceProjects';
  getServicePWANotesUrl = this.apiUrl + 'PWA/Get/Service/Notes';
  getServicePWAAttachmentsUrl = this.apiUrl + 'PWA/Get/Service/Attachments';
  getServicePWAVisitsUrl = this.apiUrl + 'PWA/Get/Service/ServiceVisits';
  getServicePWAProposalsUrl = this.apiUrl + 'PWA/Get/Service/Proposals';
  getServicePWAProdWrapUpsUrl =
    this.apiUrl + 'PWA/Get/Service/ProductionWrapUps';
  getServicePWAProdVisitsUrl = this.apiUrl + 'PWA/Get/Service/ProdVisit';
  getServicePWAUpsellContractsUrl =
    this.apiUrl + 'PWA/Get/Service/UpSellContracts';
  getServicePWAGeneratedUpsellContractsUrl =
    this.apiUrl + 'PWA/Get/Service/GeneratedUpsellContracts';
  getServicePWAProdProjectsUrl = this.apiUrl + 'PWA/Get/Service/ProdProjects';
  getServicePWAContactMethodsUrl =
    this.apiUrl + 'PWA/Get/Service/ContactMethods';
  getServicePWASoldSheetsUrl = this.apiUrl + 'PWA/Get/Service/SoldSheets';
  getServicePWAContractsUrl = this.apiUrl + 'PWA/Get/Service/Contracts';

  // PWA Shared
  getPWACalendarNotesUrl =
    this.apiUrl + 'PWA/Get/CalendarNotes/%7Buserid,function%7D?';
  postPWACalendarNoteUrl = this.apiUrl + 'PWA/Post/CalendarNotes';
  logPWAJsonBackUpUrl =
    this.apiUrl +
    'PWA/LogJson/BackUp/%7BuserId,userName,loggedDate,functionName%7D?';
  getPWAMailingRequestsUrl =
    this.apiUrl + 'PWA/Get/MailingRequests/%7Buserid,functionName%7D?';
  getPWADrawingsUrl =
    this.apiUrl + 'PWA/Get/Drawings/%7BuserId,functionName,hotQuote%7D?';
  postOfflineUserSyncDownLogUrl =
    this.apiUrl + 'PWA/OfflineUserSyncDownLog/Post';
  getPWAProductPricingUrl =
    this.apiUrl + 'PWA/ProductPricing/Get/%7BuserId,functionName%7D?';

  // Posts
  insertCustomerUrl = this.apiUrl + 'customers';
  insertJobAddressUrl = this.apiUrl + 'JobAddress';
  insertLeadUrl = this.apiUrl + 'lead';
  insertAppointmentUrl = this.apiUrl + 'Appoinment';
  insertUserUrl = this.apiUrl + 'admin/users/post';
  insertEstimatorAvailabilityUrl = this.apiUrl + 'EstAvailSkill/Insert';
  insertCustomerVisitUrl = this.apiUrl + 'CustomerVisit/Post';
  // insertProposalUrl = this.apiUrl + 'Proposal/Insert';
  insertNoteUrl = this.apiUrl + 'Notes/Post';
  insertContractUrl = this.apiUrl + 'Contracts/Post';
  // insertCustomerVisitFollowUpUrl = this.apiUrl + 'CustomerVisit/PostFollowup';
  projectPostUrl =
    this.apiUrl + 'Project/Post/%7Bcompany_code,proposalid, status%7D?';
  insertProdAppointmentUrl =
    this.apiUrl + 'ProductionScheduling/PostScheduledProject';
  insertProductionUrl = this.apiUrl + 'Production/Post';
  insertChangeOrderUrl = this.apiUrl + 'ChangeOrder/Insert';
  insertUpsellUrl = this.apiUrl + 'Upsell/Insert';
  insertServiceAppointmentUrl = this.apiUrl + 'ServiceScheduling/Post';
  insertServiceCallUrl = this.apiUrl + 'Service/Call/Insert';
  insertServiceProjectUrl = this.apiUrl + 'Service/Project/Insert';
  insertServiceVisitUrl = this.apiUrl + 'ServiceVisit/Post';
  postGeneratedContractUrl = this.apiUrl + 'Contracts/postGeneratedContract';
  insertProductionWrapUpUrl = this.apiUrl + 'Production/Post/WrapUp';
  insertServiceWrapUpUrl = this.apiUrl + 'ServiceVisit/Post/WrapUp';
  insertSoldSheetUrl = this.apiUrl + 'Contracts/postSoldSheet';
  insertPermitUrl = this.apiUrl + 'Permits/Post';
  insertUtilityUrl = this.apiUrl + 'Utility/Post';
  insertCalendarNoteUrl = this.apiUrl + 'CalendarNotes/Post';
  insertCCLContactUrl = this.apiUrl + 'CCL/Post';
  insertChangeOrderContractUrl = this.apiUrl + 'ChangeOrder/Contract/Insert';
  insertGeneratedChangeOrderContractUrl =
    this.apiUrl + 'ChangeOrder/GeneratedContract/Insert';
  insertContactMethodUrl = this.apiUrl + 'Customer/Post/ContactMethod';

  insertSalesPWADataUrl = this.apiUrl + 'PWA/Post/SalesInfo';
  insertProdPWADataUrl = this.apiUrl + 'PWA/Post/ProductionInfo';
  insertServicePWADataUrl = this.apiUrl + 'PWA/Post/ServiceInfo';
  insertPWAAttachmentsUrl = this.apiUrl + 'Attachment/getOffline/attachments';
  insertProposalUrl = this.apiUrl + 'Proposal/Post';
  insertFollowUpUrl = this.apiUrl + 'FollowUp/Post';
  insertInsideSalesContractUrl = this.apiUrl + 'Contracts/InsideSales/Post';
  insertInsideSalesGeneratedContractUrl =
    this.apiUrl + 'Contracts/InsideSales/Generated/Post';
  insertInsideSalesSoldSheetUrl =
    this.apiUrl + 'Contracts/InsideSales/SoldSheet/Post';
  insertForemanZoneUrl = this.apiUrl + 'User/Foreman/Zone/Post';
  insertMailingRequestsUrl = this.apiUrl + 'Customer/Post/MailingRequests';
  insertDrawingUrl = this.apiUrl + 'Drawings/Post';
  insertInvoiceUrl = this.apiUrl + 'ProductionManagement/Post/Invoice';
  insertGeneratedInvoiceUrl =
    this.apiUrl + 'ProductionManagement/Post/GeneratedInvoice';
  insertBillingStatementUrl =
    this.apiUrl + 'ProductionManagement/Post/BillingStatement';
  insertDailyMaterialUrl = this.apiUrl + 'ProdDailies/Materials/Post';
  insertDailyPaymentInfoUrl =
    this.apiUrl + 'ProductionManagement/Post/DailyPaymentInfo';
  insertCrewUrl = this.apiUrl + 'ProdDailies/Crews/Post';
  insertTimeLogUrl = this.apiUrl + 'ProdDailies/TimeLogs/Post';
  insertTimeBreakDownUrl = this.apiUrl + 'ProdDailies/TimeBreakDowns/Post';
  insertDailyPromptUrl = this.apiUrl + 'ProdDailies/DailyPrompt/Post';
  insertProdDailyUrl = this.apiUrl + 'ProdDailies/ProdDaily/Post';
  insertEstimatorPriorityUrl = this.apiUrl + 'EstimatorPriority/Post';
  insertZipcodeUrl = this.apiUrl + 'Post/Zipcode';
  insertCommissionInfoUrl = this.apiUrl + 'SalesManagement/Post/CommissionInfo';
  insertCommissionExceptionUrl =
    this.apiUrl + 'SalesManagement/Post/CommissionException';
  insertDoNotCallUrl = this.apiUrl + 'Customer/Post/DoNotCall';

  // Updates
  updateCustomerUrl = this.apiUrl + 'Customers';
  updateLeadUrl = this.apiUrl + 'lead/%7Bid%7D?';
  updateCustomerVisitUrl = this.apiUrl + 'CustomerVisit/Update';
  updateProposalUrl =
    this.apiUrl +
    'Proposal/Update/%7BproposalId,status,proposalStatusName,IsGenerated, customervisitId%7D?';
  updateContractUrl = this.apiUrl + 'Contracts/Put';
  updateUserUrl = this.apiUrl + 'Admin/Users/Put';
  updateAppointmentUrl = this.apiUrl + 'Appointment/Update';
  updateProjectRequirementsUrl =
    this.apiUrl +
    'Project/Put/Requirements/%7Bcompany_code,projectid,needsPermit,needsUtilities%7D?';
  updatePermitUrl = this.apiUrl + 'Permits/Update';
  updateUtilityUrl = this.apiUrl + 'Utility/Update';
  updateCalendarNoteUrl = this.apiUrl + 'CalendarNotes/Update';
  updateProdAppointmentUrl =
    this.apiUrl +
    'ProductionScheduling/Update/%7BprodSchedId,startTimeUTC,endTimeUTC,updatedBy,projectId%7D?';
  updateServAppointmentUrl =
    this.apiUrl +
    'ServiceScheduling/Update/%7BservAppointmentId,startTimeUTC,endTimeUTC,updatedBy%7D?';
  updateSalesManagerNotesUrl =
    this.apiUrl +
    'Contracts/Update/SalesManagerNotes/%7Bcompany_code,contractid,salesManagerNotes%7D?';
  updateJobAddressUrl = this.apiUrl + 'JobAddress/Update';
  updateCCLContactUrl = this.apiUrl + 'CCL/Update';
  updateAttachmentLabelUrl = this.apiUrl + 'Attachment/Update/AttachmentLabel';
  updateChangeOrderContractUrl = this.apiUrl + 'ChangeOrder/Contract/Update';
  updateGeneratedChangeOrderContractUrl =
    this.apiUrl + 'ChangeOrder/GeneratedContract/Update';
  approveChangeOrderUrl =
    this.apiUrl +
    'ChangeOrder/Approve/%7Bcompany_code,changeOrderId,approvedById,approvedByName%7D?';
  updateInsideSalesProposalUrl = this.apiUrl + 'Proposal/Update/InsideSales';
  updateContactMethodUrl = this.apiUrl + 'Customer/Update/ContactMethod';
  updateGeneratedContractUrl = this.apiUrl + 'Contracts/Generated/Put';
  updateMailingRequestUrl = this.apiUrl + 'Customer/Put/MailingRequests';
  updateDrawingUrl = this.apiUrl + 'Drawings/Put';
  updateProjectNotesUrl =
    this.apiUrl + 'Project/Put/ProjectNotes/%7BprojectId,projectNotes%7D?';
  updateServiceProjectNotesUrl =
    this.apiUrl +
    'Service/Project/Put/ProjectNotes/%7BserviceProjectId,projectNotes%7D?';
  updateEstimatorPriorityUrl = this.apiUrl + 'EstimatorPriority/Put';
  updateProjectUrl = this.apiUrl + 'ProductionManagement/Update/Project';
  updateProdDailyUrl = this.apiUrl + 'ProductionManagement/Update/ProdDaily';
  updateDailyMaterialUrl = this.apiUrl + 'ProdDailies/Materials/Update';
  updateLeadZoneUrl =
    this.apiUrl +
    'Update/LeadZone/%7BcleadId,zip,zoneid,zoneName,geoZoneId,geoZoneName%7D?';
  cancelProjectUrl =
    this.apiUrl +
    'Project/Cancel/%7BprojectId,cancellationReason,userId,userName%7D?';
  // Prod Visit
  updateProductionUrl = this.apiUrl + 'Production/Update';
  // Service Call
  updateServiceProjectUrl = this.apiUrl + 'Service/Project/Update';
  // Service Visit
  updateServiceVisitUrl = this.apiUrl + 'ServiceVisit/Update';
  updateDailyPaymentInfoUrl =
    this.apiUrl + 'ProductionManagement/Update/DailyPaymentInfo';

  // Deletes
  deleteEstimatorAvailabilityUrl = this.apiUrl + 'EstAvailSkill/Delete';
  deleteProdAppointmentUrl =
    this.apiUrl + 'ProductionScheduling/Delete/%7BprodschedId,projectid%7D?';
  deleteServiceAppointmentUrl =
    this.apiUrl + 'ServiceScheduling/Delete/%7BservAppointmentId,serviceId%7D?';
  deleteSalesAppointmentUrl =
    this.apiUrl + 'Appointment/Delete/%7Bcompany_code,AppointmentId,leadId%7D?';
  deletePermitUrl = this.apiUrl + 'Permits/Delete/%7Bcompany_code,permitId%7D?';
  deleteUtilityUrl =
    this.apiUrl + 'Utility/Delete/%7Bcompany_code,utilityId%7D?';
  deleteCalendarNoteUrl = this.apiUrl + 'CalendarNotes/Delete';
  deleteContactMethodUrl = this.apiUrl + 'Customer/Delete/ContactMethod';
  deleteProposalUrl = this.apiUrl + 'Proposal/Delete';
  deleteDrawingUrl = this.apiUrl + 'Drawings/Delete';
  deleteChangeOrderUrl =
    this.apiUrl + 'ChangeOrder/Delete/%7Bcompany_code,changeOrderId%7D?';
  deleteDailyMaterialUrl =
    this.apiUrl +
    'ProdDailies/Materials/Delete/%7Bcompany_code,dailyMaterialId%7D?';
  deleteTimeLogUrl =
    this.apiUrl + 'ProdDailies/TimeLog/Delete/%7Bcompany_code,timeLogId%7D?';
  deleteTimeBreakDownUrl =
    this.apiUrl +
    'ProdDailies/TimeBreakDowns/Delete/%7Bcompany_code,timeBreakDownId%7D?';
  deleteInvoiceUrl =
    this.apiUrl + 'ProdDailies/Invoice/Delete/%7Bcompany_code,projectId%7D?';
  deleteForemanZonesUrl = this.apiUrl + 'User/Foreman/Zone/Delete';

  // Attachments
  getAttachmentsUrl = this.apiUrl + 'Attachment/download';
  getAttachmentInfoUrl =
    this.apiUrl + 'Attachment/%7Bjobaddressid,customerid%7D?';
  getAttachmentsByFunctionIdUrl =
    this.apiUrl +
    'Attachment/byFunction/%7BjobAddressId,functionId,function%7D?';
  getAllVehicleDocumentationAttachmentsUrl =
    this.apiUrl + 'Attachment/GetAll/VehicleDocumentation';
  getContractAttachmentsByContractIdUrl = this.apiUrl + 'Attachment/ByContractId';
  getDrawingAttachmentsByJobAddressIdUrl = this.apiUrl + 'Attachment/Drawings/ByJobAddressId';
  insertAttachmentUrl = this.apiUrl + 'Attachment';
  insertChooseFileUrl =
    this.apiUrl +
    'Files/uploadFiles/%7Bjobaddressid,customerid,functionName,functionId%7D?';
  deleteAttachmentUrl = this.apiUrl + 'Attachment/Delete';

  // Reports
  getAvailableReportsUrl =
    this.apiUrl + 'Reports/Get/AvailableReports/%7Bcompany_code,roleName%7D?';
  getReportInfoByIdUrl =
    this.apiUrl + 'Reports/Get/ReportInfoById/%7Bcompany_code,reportId%7D?';
  getLeadsByDateReportUrl =
    this.apiUrl +
    'Reports/Get/LeadsbyDate/%7Bcompany_code,startDate,endDate,leadSourceName,zoneName,proposalStatusName,leadTypeName%7D?';
  getLeadsByDateParametersUrl =
    this.apiUrl + 'Reports/Get/LeadsByDate/Parameters';
  getBOMReportUrl =
    this.apiUrl + 'Reports/Get/BOM/%7Bcompany_code,zoneName%7D?';
  getBOMParametersUrl = this.apiUrl + 'Reports/Get/BOM/Parameters';
  getClosingPercentageReportUrl =
    this.apiUrl +
    'Reports/Get/ClosingPercentage/%7Bcompany_code,startDate,endDate,userId%7D?';
  getClosingPercentageParametersUrl =
    this.apiUrl + 'Reports/Get/ClosingPercentage/Parameters';
  getIVPDDetailedReportUrl =
    this.apiUrl +
    'Reports/Get/IVPD/%7Bcompany_code,startDate,endDate,zoneName,foremanName,projectTypeName,detail%7D?';
  getIVPDGroupedReportUrl =
    this.apiUrl +
    'Reports/Get/IVPD/%7Bcompany_code,startDate,endDate,zoneName,foremanName,projectTypeName,detail%7D?';
  getIVPDParametersUrl = this.apiUrl + 'Reports/Get/IVPD/Parameters';
  getMarkedAsSoldReportUrl =
    this.apiUrl +
    'Reports/Get/SoldProposals/%7Bcompany_code,startDate,endDate,estimator,zoneName%7D?';
  getMarkedAsSoldParametersUrl =
    this.apiUrl + 'Reports/Get/SoldProposals/Parameters';
  getApprovedJobsReportUrl =
    this.apiUrl +
    'Reports/Get/ApprovedJobs/%7Bcompany_code,startDate,endDate%7D?';
  getProjectClosingPercentageReportUrl =
    this.apiUrl +
    'Reports/Get/ProjectClosingPercentage/%7Bcompany_code,startDate,endDate,estimator,projectTypeName%7D?';
  getProjectClosingPercentageParametersUrl =
    this.apiUrl + 'Reports/Get/ProjectClosingPercentage/Parameters';
  getSalesOverviewSummaryReportUrl =
    this.apiUrl +
    'Reports/Get/SalesOverview/Summary/%7Bcompany_code,startDate,endDate%7D?';
  getSalesOverviewDetailReportUrl =
    this.apiUrl +
    'Reports/Get/SalesOverview/Detail/%7Bcompany_code,startDate,endDate%7D?';
  getBiddingPercentageReportUrl =
    this.apiUrl +
    'Reports/Get/BiddingPercentage/%7Bcompany_code,startDate,endDate%7D?';
  getAppointmentsCreatedReportUrl =
    this.apiUrl +
    'Reports/Get/AppointmentsCreated/%7Bcompany_code,startDate,endDate%7D?';
  getServiceAppointmentsCreatedReportUrl =
    this.apiUrl +
    'Reports/Get/ServiceAppointmentsCreated/%7Bcompany_code,startDate,endDate%7D?';
  getCommissionOlogReportUrl =
    this.apiUrl +
    'Reports/Get/CommissionOlogReport/%7Bcompany_code,startDate,endDate%7D?';
  getCommissionPaymentsByPayrollWeekReportUrl =
    this.apiUrl +
    'Reports/Get/CommissionPaymentsByPayrollWeekReport/%7Bcompany_code,startDate,endDate%7D?';
  // KPI
  getWeeklyLeadsKPIUrl =
    this.apiUrl + 'KPI/Get/WeeklyLeads/%7Bcompany_code,startDate,endDate%7D?';
  getWeeklyCallCenterKPIUrl =
    this.apiUrl +
    'KPI/Get/WeeklyCallCenter/%7Bcompany_code,startDate,endDate%7D?';

  // Google Maps
  geoCodeAddressUrl = this.apiUrl + 'GoogleMaps/GeoCode';
  getTimeZoneUrl = this.apiUrl + 'GoogleMaps/TimeZone/%7Blat,lng,timestamp%7D?';

  constructor(
    private http: HttpClient,
    private localStorage: LocalStorageService
  ) {}

  accutraxAPIHeaders: HttpHeaders = new HttpHeaders().set(
    'Accutrax-API-Key',
    environment.accutraxAPIKey
  );

  //#region GET
  getServerStatus(): Observable<string> {
    return this.http.get<string>(this.getServerStatusUrl, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getCustomerData(): Observable<Customer[]> {
    return this.http.get<Customer[]>(this.getCustomersUrl, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getCustomerById(id: number): Observable<Customer> {
    return this.http.get<Customer>(this.getCustomerByIdUrl + '/' + id, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getJobAddressInfo(
    customerId?: string,
    jobAddressId?: number
  ): Observable<JobAddressInfo[]> {
    let params = new HttpParams();
    customerId
      ? (params = params.set('custid', customerId))
      : (params = params.set('custid', ''));
    jobAddressId
      ? (params = params.set('id', jobAddressId))
      : (params = params.set('id', ''));

    return this.http.get<JobAddressInfo[]>(this.getJobAddressInfoUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getLeadData(id: number): Observable<Lead> {
    return this.http.get<Lead>(this.getLeadUrl + '/' + id, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getLeadSources(company_Code?: string): Observable<LeadSource[]> {
    if (company_Code) {
      return this.http.get<LeadSource[]>(
        this.leadSourcesUrl + '/' + company_Code,
        {
          headers: this.accutraxAPIHeaders,
        }
      );
    } else {
      return this.http.get<LeadSource[]>(
        this.leadSourcesUrl + '/' + this.localStorage.get('companyCode'),
        {
          headers: this.accutraxAPIHeaders,
        }
      );
    }
  }

  getLeadSubSources(
    leadSourceId: number,
    company_Code?: string
  ): Observable<LeadSubSource[]> {
    let params = new HttpParams().set(
      'company_code',
      company_Code ? company_Code : this.localStorage.get('companyCode')
    );
    params = params.set('leadSourceId', leadSourceId);
    return this.http.get<LeadSubSource[]>(this.leadSubSourcesUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getLeadTypes(company_Code?: string): Observable<LeadType[]> {
    if (company_Code) {
      return this.http.get<LeadType[]>(this.getLeadTypesUrl + company_Code, {
        headers: this.accutraxAPIHeaders,
      });
    } else {
      return this.http.get<LeadType[]>(
        this.getLeadTypesUrl + this.localStorage.get('companyCode'),
        {
          headers: this.accutraxAPIHeaders,
        }
      );
    }
  }

  getSalesCalendar(
    employeeid: string,
    date: string
  ): Observable<SalesCalendarEvent[]> {
    let params = new HttpParams().set('date', date);
    params = params.set('employeeId', employeeid);
    return this.http.get<SalesCalendarEvent[]>(this.getSalesCalendarUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  customerSearch(
    searchTerms?: Customersearch
  ): Observable<CustomerSearchResults[]> {
    let params = new HttpParams();
    if (searchTerms?.lastName) {
      params = params.set('lastname', searchTerms?.lastName);
    } else {
      params = params.set('lastname', '');
    }
    if (searchTerms?.jobAddress) {
      params = params.set('jobaddress', searchTerms?.jobAddress);
    } else {
      params = params.set('jobaddress', '');
    }
    if (searchTerms?.phoneNumber) {
      params = params.set('phoneNumber', searchTerms?.phoneNumber);
    } else {
      params = params.set('phoneNumber', '');
    }
    if (searchTerms?.customerId) {
      params = params.set('customerId', searchTerms?.customerId);
    } else {
      params = params.set('customerId', '');
    }
    if (searchTerms?.projectId) {
      params = params.set('projectId', searchTerms?.projectId);
    } else {
      params = params.set('projectId', '');
    }

    return this.http.get<CustomerSearchResults[]>(this.searchCustomerUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getEstimatorsForSmartScheduler(
    geoZoneId: Number,
    leadType: Number,
    leadSourceId: Number,
    company_code?: string
  ): Observable<EstimatorPriority[]> {
    let params = new HttpParams().set(
      'company_code',
      company_code ? company_code : this.localStorage.get('companyCode')
    );
    params = params.set('geoZoneId', geoZoneId.toString());
    params = params.set('leadType', leadType.toString());
    params = params.set('leadSourceId', leadSourceId.toString());
    return this.http.get<EstimatorPriority[]>(
      this.getEstimatorsForSmartSchedulerUrl,
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  getSmartSchedulerData(
    userName: string,
    geoZoneId: Number,
    leadType: Number,
    jobAddress: string,
    jobAddressId: number,
    leadId: number,
    selectedEstimators: EstimatorPriority[],
    company_code?: string
  ): Observable<SmartSchedulerResponse> {
    let params = new HttpParams().set('userName', userName);
    params = params.set('geoZone', geoZoneId.toString());
    params = params.set('leadType', leadType.toString());
    params = params.set('jobAddress', jobAddress);
    params = params.set(
      'company_code',
      company_code ? company_code : this.localStorage.get('companyCode')
    );
    params = params.set('jobAddressId', jobAddressId.toString());
    params = params.set('leadId', leadId.toString());
    params = params.set(
      'selectedEstimators',
      JSON.stringify(selectedEstimators)
    );
    return this.http.get<SmartSchedulerResponse>(
      this.getSmartSchedulerDataUrl,
      { headers: this.accutraxAPIHeaders, params }
    );
  }

  // Only to be used in smart scheduler. Only works after data has been processed
  getProcessedAvailability(userName: string): Observable<Availability[]> {
    return this.http.get<Availability[]>(
      this.getProcesssedAvailabilityUrl + userName,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getGeoZoneByZip(company_code: string, zipcode: string): Observable<Geozone> {
    let params = new HttpParams()
      .set('company_code', company_code)
      .set('zipcode', zipcode);
    return this.http.get<Geozone>(this.getGeoZoneByZipUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getUserData(userid?: string, name?: string): Observable<User[]> {
    let params = new HttpParams();
    userid
      ? (params = params.set('userid', userid))
      : (params = params.set('userid', ''));
    name
      ? (params = params.set('name', name))
      : (params = params.set('name', ''));
    return this.http.get<User[]>(this.getUserDataUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getEstimatorAvailability(
    userId: string
  ): Observable<EstimatorAvailability[]> {
    return this.http.get<EstimatorAvailability[]>(
      this.getEstimatorAvailabilityUrl + '/' + userId,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getRoles(): Observable<Role[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('desc', '');
    return this.http.get<Role[]>(this.getRolesUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getAllGeoZones(): Observable<GeoZoneFull[]> {
    return this.http.get<GeoZoneFull[]>(this.getAllGeoZonesUrl, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getEstimators(): Observable<Estimator[]> {
    return this.http.get<Estimator[]>(this.getEstimatorsUrl, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getAppointmentInfo(appointmentId: number): Observable<Appointment> {
    return this.http.get<Appointment>(
      this.getAppointmentUrl + '/' + appointmentId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getAllProducts(): Observable<ProductSubCategory[]> {
    return this.http.get<ProductSubCategory[]>(
      this.getAllProductsUrl + '/' + this.localStorage.get('companyCode'),
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getAllJobAddressInfo(jobAddressId: number): Observable<FullJobAddressInfo> {
    return this.http.get<FullJobAddressInfo>(
      this.getAllJobAddressInfoUrl + '/' + jobAddressId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getCustomerVisit(appointmentId: number): Observable<CustomerVisit[]> {
    return this.http.get<CustomerVisit[]>(
      this.getCustomerVisitUrl + '/' + appointmentId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProposalDetails(proposalId: string): Observable<Proposal> {
    return this.http.get<Proposal>(
      this.getProposalDetailsUrl + '/' + proposalId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProposalStatements(functionId: string): Observable<Statement[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('proposalid', functionId);
    return this.http.get<Statement[]>(this.getStatementsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getNoBidReasons(): Observable<NoBidReason[]> {
    return this.http.get<NoBidReason[]>(
      this.getNoBidReasonsUrl + '/' + this.localStorage.get('companyCode'),
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProposalIdByCustomerVisitId(
    customerVisitId: string
  ): Observable<string[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );

    params = params.set('customerVisitId', customerVisitId);

    return this.http.get<string[]>(this.getProposalIdsByCustomerVisitIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getStatusesBySection(section: string): Observable<Status[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('section', section);
    return this.http.get<Status[]>(this.getStatusesBySectionUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getUsersByRole(roleName: string): Observable<User[]> {
    return this.http.get<User[]>(this.getUsersByRoleUrl + '/' + roleName, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getProductionSchedule(
    weekDate: string,
    monthDate: string,
    userId: string
  ): Observable<ProdAvailability[]> {
    let params = new HttpParams().set('wDate', weekDate);
    params = params.set('mDate', monthDate);
    params = params.set('userId', userId);

    return this.http.get<ProdAvailability[]>(this.getProductionScheduleUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProjectById(projectId: number): Observable<Project> {
    return this.http.get<Project>(this.getProjectByIdUrl + '/' + projectId, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getForemanByProjectTypeAndGeoZone(projectTypeId: number, geoZoneId: number) {
    let params = new HttpParams().set('projectTypeid', projectTypeId);
    params = params.set('geozoneid', geoZoneId);
    return this.http.get<User[]>(this.getForemanByProjectTypeAndGeoZoneUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getAllZones(): Observable<Zone[]> {
    return this.http.get<Zone[]>(this.getAllZonesUrl, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getForemanByZone(zoneId: number, date: string): Observable<User[]> {
    let params = new HttpParams().set('zoneid', zoneId);
    params = params.set('date', date);
    return this.http.get<User[]>(this.getForemanByZoneUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  // Prod visit
  // No longer in use
  // getProductionById(productionId: string): Observable<Production[]> {
  //   let params = new HttpParams().set(
  //     'company_code',
  //     this.localStorage.get('companyCode')
  //   );
  //   params = params.set('productionId', productionId);
  //   return this.http.get<Production[]>(this.getProductionUrl, {
  //     headers: this.accutraxAPIHeaders,
  //     params,
  //   });
  // }

  getProductionByProdSchedId(prodSchedId: number): Observable<Production[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('prodschedId', prodSchedId);
    return this.http.get<Production[]>(this.getProductionByProdSchedIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProdApptByProdSchedId(prodSchedId: number): Observable<ProdAppointment> {
    return this.http.get<ProdAppointment>(
      this.getProdApptByProdSchedIdUrl + '/' + prodSchedId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  // Service visit & schedule
  getServiceSchedule(
    weekDate: string,
    monthDate: string,
    userId: string
  ): Observable<ServiceAvailability[]> {
    let params = new HttpParams().set('wDate', weekDate);
    params = params.set('mDate', monthDate);
    params = params.set('userId', userId);

    return this.http.get<ServiceAvailability[]>(
      this.getServiceAvailabilityUrl,
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  getServiceTechsByProjectTypeAndGeoZone(
    projectTypeId: number,
    geoZoneId: number
  ) {
    let params = new HttpParams().set('projectTypeid', projectTypeId);
    params = params.set('geozoneid', geoZoneId);
    return this.http.get<User[]>(this.getServiceByProjectTypeAndGeoZoneUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProjectsByJobAddress(jobAddressId: number): Observable<Project[]> {
    return this.http.get<Project[]>(
      this.getProjectsByJobAddressUrl + '/' + jobAddressId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getAccountingInfoByProjectId(projectId: number): Observable<AccountingInfo> {
    return this.http.get<AccountingInfo>(
      this.getAccountingInfoByProjectIdUrl + '/' + projectId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getServiceProjectById(serviceProjectId: number): Observable<ServiceProject> {
    return this.http.get<ServiceProject>(
      this.getServiceProjectByIdUrl + '/' + serviceProjectId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getServiceTechByZone(zoneId: number): Observable<User[]> {
    return this.http.get<User[]>(this.getServiceTechByZoneUrl + '/' + zoneId, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getServiceAppointmentById(
    serviceApptId: number
  ): Observable<ServiceAppointment> {
    return this.http.get<ServiceAppointment>(
      this.getServiceApptByIdUrl + '/' + serviceApptId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getServiceVisitByServiceApptId(
    serviceApptId: number
  ): Observable<ServiceVisit[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('serviceAppointmentId', serviceApptId);
    return this.http.get<ServiceVisit[]>(
      this.getServiceVisitByServiceApptIdUrl,
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  // Notes
  getNotesByJobAddress(jobAddressId: number): Observable<Note[]> {
    return this.http.get<Note[]>(
      this.getNotesByJobAddressUrl + '/' + jobAddressId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getCustomerNotes(customerId: number): Observable<Note[]> {
    return this.http.get<Note[]>(this.getCustomerNotesUrl + '/' + customerId, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getNotesByFunction(
    functionId: number | string,
    functionName: string
  ): Observable<Note[]> {
    let params = new HttpParams().set('functionid', functionId);
    params = params.set('functionname', functionName);

    return this.http.get<Note[]>(this.getNotesByFunctionUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProductionByProjectId(projectId: number): Observable<Production[]> {
    return this.http.get<Production[]>(
      this.getProductionByProjectIdUrl + '/' + projectId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProductionByContractId(contractId: number): Observable<Production[]> {
    return this.http.get<Production[]>(
      this.getProductionByContractIdUrl + '/' + contractId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  // getPWAData(userId: string): Observable<PWAModel[]> {
  //   let params = new HttpParams().set(
  //     'company_code',
  //     this.localStorage.get('companyCode')
  //   );
  //   params = params.set('userid', userId);
  //   return this.http.get<PWAModel[]>(this.getPWADataUrl, {
  //     headers: this.accutraxAPIHeaders,
  //     params,
  //   });
  // }

  getLastEstimator(jobAddressId: number): Observable<LastEstimator | null> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('jobaddressid', jobAddressId);
    return this.http.get<LastEstimator | null>(this.getLastEstimatorUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getSoldSheet(contractId: number): Observable<SoldSheet> {
    return this.http.get<SoldSheet>(this.getSoldSheetUrl + '/' + contractId, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getUpsellById(upsellId: string): Observable<Upsell> {
    return this.http.get<Upsell>(this.getUpsellByIdUrl + '/' + upsellId, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getServiceVisitByServiceProjectId(
    serviceProjectId: number
  ): Observable<ServiceVisit[]> {
    return this.http.get<ServiceVisit[]>(
      this.getServiceVisitByServiceProjectIdUrl + '/' + serviceProjectId,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getUpsellProducts(
    userId: string,
    functionName: string
  ): Observable<ProductSubCategory[]> {
    let params = new HttpParams().set('userId', userId);
    params = params.set('functionName', functionName);

    return this.http.get<ProductSubCategory[]>(this.getUpsellProductsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProposalsByAppointmentId(appointmentId: number): Observable<Proposal[]> {
    return this.http.get<Proposal[]>(
      this.getProposalsByAppointmentIdUrl + '/' + appointmentId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getPendingDeadLead(leadId: number): Observable<Lead | undefined> {
    return this.http.get<Lead | undefined>(
      this.getPendingDeadLeadUrl + '/' + leadId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getPendingChangeOrders(): Observable<ChangeOrder[]> {
    return this.http.get<ChangeOrder[]>(
      this.getPendingChangeOrdersUrl +
        '/' +
        this.localStorage.get('companyCode'),
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getAllDispositions(
    userId: string,
    functionName: string
  ): Observable<Disposition[]> {
    let params = new HttpParams().set('userId', userId);
    params = params.set('functionName', functionName);

    return this.http.get<Disposition[]>(this.getAllDispositionsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getAllSubDispositions(
    userId: string,
    functionName: string
  ): Observable<SubDisposition[]> {
    let params = new HttpParams().set('userId', userId);
    params = params.set('functionName', functionName);

    return this.http.get<SubDisposition[]>(this.getAllSubDispositionsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getAllNoBidReasons(
    userId: string,
    functionName: string
  ): Observable<NoBidReason[]> {
    let params = new HttpParams().set('userId', userId);
    params = params.set('functionName', functionName);

    return this.http.get<NoBidReason[]>(this.getAllNoBidReasonsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getAppointmentsByJobAddressId(
    jobAddressId: number
  ): Observable<Appointment[]> {
    return this.http.get<Appointment[]>(
      this.getAppointmentsByJobAddressIdUrl + '/' + jobAddressId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProductionAppointmentsByJobAddressId(
    jobAddressId: number
  ): Observable<ProdAppointment[]> {
    return this.http.get<ProdAppointment[]>(
      this.getProdAppointmentsByJobAddressIdUrl + '/' + jobAddressId,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getServiceAppointmentsByJobAddressId(
    jobAddressId: number
  ): Observable<ServiceAppointment[]> {
    return this.http.get<ServiceAppointment[]>(
      this.getServiceAppointmentsByJobAddressIdUrl + '/' + jobAddressId,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getAllFollowUps(userId: string): Observable<FollowUp[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('userId', userId);
    return this.http.get<FollowUp[]>(this.getAllFollowUpsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getServiceProjectsByJobAddressId(
    jobAddressId: number
  ): Observable<ServiceProject[]> {
    return this.http.get<ServiceProject[]>(
      this.getServiceProjectsByJobAddressIdUrl + '/' + jobAddressId,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getNotesByFunctionName(
    jobAddressId: number,
    functionName: string
  ): Observable<Note[]> {
    let params = new HttpParams().set('jobAddressId', jobAddressId);
    params = params.set('functionName', functionName);
    return this.http.get<Note[]>(this.getNotesByFunctionNameUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getAppointmentsByLeadId(leadId: number): Observable<Appointment[]> {
    return this.http.get<Appointment[]>(
      this.getAppointmentsByLeadIdUrl + '/' + leadId,
      { headers: this.accutraxAPIHeaders }
    );
  }

  //#endregion

  // #region attachments
  getFile(attachmentId?: number): Observable<Attachment> {
    return this.http.get<Attachment>(
      this.getAttachmentsUrl + '/' + attachmentId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getAttachments(
    customerId?: number,
    jobAddressId?: number
  ): Observable<Attachment[]> {
    let params = new HttpParams();
    jobAddressId
      ? (params = params.set('jobaddressId', jobAddressId))
      : (params = params.set('jobaddressId', ''));
    customerId
      ? (params = params.set('customerId', customerId))
      : (params = params.set('customerId', ''));

    return this.http.get<Attachment[]>(this.getAttachmentInfoUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getAttachmentsByFunctionId(
    jobaddressid: number,
    functionId: string,
    functionName: string
  ): Observable<Attachment[]> {
    let params = new HttpParams().set('jobAddressId', jobaddressid);
    params = params.set('functionId', functionId);
    params = params.set('function', functionName);

    return this.http.get<Attachment[]>(this.getAttachmentsByFunctionIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getAllVehicleDocumentationAttachments(): Observable<
    VehicleDocumentationAttachment[]
  > {
    return this.http.get<VehicleDocumentationAttachment[]>(
      this.getAllVehicleDocumentationAttachmentsUrl,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getContractAttachmentsByContractId(contractId: number): Observable<Attachment> {
    return this.http.get<Attachment>(
      this.getContractAttachmentsByContractIdUrl + '/' + contractId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getDrawingAttachmentsByJobAddressId(jobAddressId: number): Observable<Attachment[]> {
    return this.http.get<Attachment[]>(
      this.getDrawingAttachmentsByJobAddressIdUrl + '/' + jobAddressId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  saveAttachment(jobAddressInfo: Attachment): Observable<Attachment> {
    return this.http.post<Attachment>(
      this.insertAttachmentUrl,
      jobAddressInfo,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  saveFiles(
    formData: FormData,
    customerId?: number,
    jobAddressId?: number,
    functionName?: string,
    functionId?: string,
    attachmentLabel?: string
  ): Observable<string> {
    let params = new HttpParams();
    jobAddressId
      ? (params = params.set('jobaddressId', jobAddressId))
      : (params = params.set('jobaddressId', ''));
    customerId
      ? (params = params.set('customerId', customerId))
      : (params = params.set('customerId', ''));
    functionName
      ? (params = params.set('functionName', functionName))
      : (params = params.set('functionName', ''));
    functionId
      ? (params = params.set('functionId', functionId))
      : (params = params.set('functionId', ''));
    attachmentLabel
      ? (params = params.set('attachmentLabel', attachmentLabel))
      : (params = params.set('attachmentLabel', ''));

    return this.http.post<string>(this.insertChooseFileUrl, formData, {
      headers: this.accutraxAPIHeaders,
      params,
      withCredentials: false,
    });
  }

  deleteAttachment(attachmentId: number) {
    return this.http.delete<void>(
      this.deleteAttachmentUrl + '/' + attachmentId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }
  // #endregion

  //#region Reports
  getAvailableReports(roleName: string): Observable<ReportPermissions> {
    let params = new HttpParams().set('company_code', 'HTC');
    params = params.set('roleName', roleName);
    return this.http.get<ReportPermissions>(this.getAvailableReportsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getReportInfoById(reportId: number): Observable<ReportInfo> {
    let params = new HttpParams().set('company_code', 'HTC');
    params = params.set('reportId', reportId);
    return this.http.get<ReportInfo>(this.getReportInfoByIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getLeadsByDateReport(
    formParams: { property: string; value: string | number | Date }[]
  ): Observable<LeadsByDateReport[]> {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('startDate', formParams[1].value.toString());
    params = params.set('endDate', formParams[2].value.toString());
    params = params.set('leadSourceName', formParams[3].value.toString());
    params = params.set('zoneName', formParams[4].value.toString());
    params = params.set('proposalStatusName', formParams[5].value.toString());
    params = params.set('leadTypeName', formParams[6].value.toString());
    return this.http.get<LeadsByDateReport[]>(this.getLeadsByDateReportUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getLeadsByDateParameters(
    company_Code: string
  ): Observable<LeadsByDateReportParameters> {
    return this.http.get<LeadsByDateReportParameters>(
      this.getLeadsByDateParametersUrl + '/' + company_Code,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getBOMReport(
    formParams: { property: string; value: string | number | Date }[]
  ): Observable<BOMReport[]> {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('zoneName', formParams[1].value.toString());
    return this.http.get<BOMReport[]>(this.getBOMReportUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getBOMParameters(company_Code: string): Observable<BOMReportParameters> {
    return this.http.get<BOMReportParameters>(
      this.getBOMParametersUrl + '/' + company_Code,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getClosingPercentageReport(
    formParams: { property: string; value: string | number | Date }[]
  ): Observable<ClosingPercentageReport[]> {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('startDate', formParams[1].value.toString());
    params = params.set('endDate', formParams[2].value.toString());
    params = params.set('userId', formParams[3].value.toString());
    return this.http.get<ClosingPercentageReport[]>(
      this.getClosingPercentageReportUrl,
      { headers: this.accutraxAPIHeaders, params }
    );
  }

  getClosingPercentageParameters(
    company_Code: string
  ): Observable<ClosingPercentageReportParameters> {
    return this.http.get<ClosingPercentageReportParameters>(
      this.getClosingPercentageParametersUrl + '/' + company_Code,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getIVPDDetailedReport(
    formParams: { property: string; value: string | number | Date }[]
  ): Observable<IVPDDetailReport[]> {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('startDate', formParams[1].value.toString());
    params = params.set('endDate', formParams[2].value.toString());
    params = params.set('zoneName', formParams[3].value.toString());
    params = params.set('foremanName', formParams[4].value.toString());
    params = params.set('projectTypeName', formParams[5].value.toString());
    params = params.set('detail', formParams[6].value.toString());
    return this.http.get<IVPDDetailReport[]>(this.getIVPDDetailedReportUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getIVPDGroupedReport(
    formParams: { property: string; value: string | number | Date }[]
  ): Observable<IVPDGroupedReport[]> {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('startDate', formParams[1].value.toString());
    params = params.set('endDate', formParams[2].value.toString());
    params = params.set('zoneName', formParams[3].value.toString());
    params = params.set('foremanName', formParams[4].value.toString());
    params = params.set('projectTypeName', formParams[5].value.toString());
    params = params.set('detail', formParams[6].value.toString());
    return this.http.get<IVPDGroupedReport[]>(this.getIVPDGroupedReportUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getIVPDParameters(company_Code: string): Observable<IVPDReportParameters> {
    return this.http.get<IVPDReportParameters>(
      this.getIVPDParametersUrl + '/' + company_Code,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getMarkedAsSoldReport(
    formParams: { property: string; value: string | number | Date }[]
  ): Observable<MarkedAsSoldReport[]> {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('startDate', formParams[1].value.toString());
    params = params.set('endDate', formParams[2].value.toString());
    params = params.set('estimator', formParams[3].value.toString());
    params = params.set('zoneName', formParams[4].value.toString());
    return this.http.get<MarkedAsSoldReport[]>(this.getMarkedAsSoldReportUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getMarkedAsSoldParameters(
    company_Code: string
  ): Observable<MarkedAsSoldReportParameters> {
    return this.http.get<MarkedAsSoldReportParameters>(
      this.getMarkedAsSoldParametersUrl + '/' + company_Code,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getApprovedJobsReport(
    formParams: { property: string; value: string | number | Date }[]
  ): Observable<ApprovedJobsReport[]> {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('startDate', formParams[1].value.toString());
    params = params.set('endDate', formParams[2].value.toString());
    return this.http.get<ApprovedJobsReport[]>(this.getApprovedJobsReportUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProjectClosingPercentageReport(
    formParams: { property: string; value: string | number | Date }[]
  ): Observable<ProjectClosingPercentageReport[]> {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('startDate', formParams[1].value.toString());
    params = params.set('endDate', formParams[2].value.toString());
    params = params.set('estimator', formParams[3].value.toString());
    params = params.set('projectTypeName', formParams[4].value.toString());
    return this.http.get<ProjectClosingPercentageReport[]>(
      this.getProjectClosingPercentageReportUrl,
      { headers: this.accutraxAPIHeaders, params }
    );
  }

  getProjectClosingPercentageParameters(
    company_Code: string
  ): Observable<ProjectClosingPercentageReportParameters> {
    return this.http.get<ProjectClosingPercentageReportParameters>(
      this.getProjectClosingPercentageParametersUrl + '/' + company_Code,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getSalesOverviewSummaryReport(
    formParams: { property: string; value: string | number | Date }[]
  ): Observable<SalesOverviewReport[]> {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('startDate', formParams[1].value.toString());
    params = params.set('endDate', formParams[2].value.toString());
    return this.http.get<SalesOverviewReport[]>(
      this.getSalesOverviewSummaryReportUrl,
      { headers: this.accutraxAPIHeaders, params }
    );
  }

  getSalesOverviewDetailReport(
    formParams: { property: string; value: string | number | Date }[]
  ): Observable<SalesOverviewDetailReport[]> {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('startDate', formParams[1].value.toString());
    params = params.set('endDate', formParams[2].value.toString());
    return this.http.get<SalesOverviewDetailReport[]>(
      this.getSalesOverviewDetailReportUrl,
      { headers: this.accutraxAPIHeaders, params }
    );
  }

  getBiddingPercentageReport(
    formParams: { property: string; value: string | number | Date }[]
  ) {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('startDate', formParams[1].value.toString());
    params = params.set('endDate', formParams[2].value.toString());
    return this.http.get<BiddingPercentageReport[]>(
      this.getBiddingPercentageReportUrl,
      { headers: this.accutraxAPIHeaders, params }
    );
  }

  getAppointmentsCreatedReport(
    formParams: { property: string; value: string | number | Date }[]
  ): Observable<AppointmentsCreatedReport[]> {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('startDate', formParams[1].value.toString());
    params = params.set('endDate', formParams[2].value.toString());
    return this.http.get<AppointmentsCreatedReport[]>(
      this.getAppointmentsCreatedReportUrl,
      { headers: this.accutraxAPIHeaders, params }
    );
  }

  getServiceAppointmentsCreatedReport(
    formParams: { property: string; value: string | number | Date }[]
  ): Observable<ServiceAppointmentsCreatedReport[]> {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('startDate', formParams[1].value.toString());
    params = params.set('endDate', formParams[2].value.toString());
    return this.http.get<ServiceAppointmentsCreatedReport[]>(
      this.getServiceAppointmentsCreatedReportUrl,
      { headers: this.accutraxAPIHeaders, params }
    );
  }

  getCommissionOlogReport(
    formParams: { property: string; value: string | number | Date }[]
  ): Observable<CommissionOlogReport[]> {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('startDate', formParams[1].value.toString());
    params = params.set('endDate', formParams[2].value.toString());
    return this.http.get<CommissionOlogReport[]>(
      this.getCommissionOlogReportUrl,
      { headers: this.accutraxAPIHeaders, params }
    );
  }

  getCommissionPaymentsByPayrollWeekReport(
    formParams: { property: string; value: string | number | Date }[]
  ): Observable<CommissionPaymentsByPayrollWeekReport[]> {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('startDate', formParams[1].value.toString());
    params = params.set('endDate', formParams[2].value.toString());
    return this.http.get<CommissionPaymentsByPayrollWeekReport[]>(
      this.getCommissionPaymentsByPayrollWeekReportUrl,
      { headers: this.accutraxAPIHeaders, params }
    );
  }
  //#endregion

  //#region KPIs
  getWeeklyLeadsKPI(
    formParams: { property: string; value: string | number | Date }[]
  ): Observable<WeeklyLeadsKPI[]> {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('startDate', formParams[1].value.toString());
    params = params.set('endDate', formParams[2].value.toString());
    return this.http.get<WeeklyLeadsKPI[]>(this.getWeeklyLeadsKPIUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getWeeklyCallCenterKPI(
    formParams: { property: string; value: string | number | Date }[]
  ): Observable<WeeklyCallCenterKPI[]> {
    let params = new HttpParams().set(
      'company_code',
      formParams[0].value.toString()
    );
    params = params.set('startDate', formParams[1].value.toString());
    params = params.set('endDate', formParams[2].value.toString());
    return this.http.get<WeeklyCallCenterKPI[]>(
      this.getWeeklyCallCenterKPIUrl,
      { headers: this.accutraxAPIHeaders, params }
    );
  }
  //#endregion

  //#region GET Counts
  // Get Counts
  getAllStatusCounts(): Observable<AllStatusCounts> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('userid', this.localStorage.get('uid'));
    return this.http.get<AllStatusCounts>(
      this.getAllStatusCountsUrl + '/' + this.localStorage.get('companyCode'),
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getLeadsByStatus(status: number): Observable<Lead[]> {
    return this.http.get<Lead[]>(this.getLeadsByStatusUrl + '/' + status, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getAppointmentsByStatus(status: number): Observable<Appointment[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('status', status);
    return this.http.get<Appointment[]>(this.getAppointmentsByStatusUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getCustomerVisitByStatus(status: number): Observable<CustomerVisit[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('status', status);
    return this.http.get<CustomerVisit[]>(this.getCustomerVisitsByStatusUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProposalByStatus(status: number): Observable<Proposal[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('status', status);
    return this.http.get<Proposal[]>(this.getProposalByStatusUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  // Most of these are not the right type interface. don't have the types in yet
  getSalesManagementByStatus(status: number): Observable<Contract[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('status', status);
    return this.http.get<Contract[]>(this.getSalesManagementByStatusUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProductionSchedulingByStatus(status: number): Observable<Project[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('status', status);
    return this.http.get<Project[]>(this.getProductionSchedulingByStatusUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProductionManagementByStatus(status: number): Observable<Production[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('status', status);
    return this.http.get<Production[]>(
      this.getProductionManagementByStatusUrl,
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  getServiceProjectsByStatus(status: number): Observable<ServiceProject[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('status', status);
    return this.http.get<ServiceProject[]>(this.getServiceProjectsByStatusUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getServiceManagementByStatus(status: number): Observable<ServiceVisit[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('status', status);
    return this.http.get<ServiceVisit[]>(this.getServiceManagementByStatusUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProjectsByPermitStatus(status: number): Observable<Project[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('status', status);
    return this.http.get<Project[]>(this.getPermitsByStatusUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProjectsByUtilityStatus(status: number): Observable<Project[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('status', status);
    return this.http.get<Project[]>(this.getUtilitiesByStatusUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProjectsByStatus(status: string): Observable<Project[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('status', status);
    return this.http.get<Project[]>(this.getProjectsByStatusUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getServiceVisitById(serviceVisitId: string): Observable<ServiceVisit[]> {
    return this.http.get<ServiceVisit[]>(
      this.getServiceVisitByIdUrl + '/' + serviceVisitId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getGeneratedContract(contractId: number): Observable<GeneratedContract> {
    return this.http.get<GeneratedContract>(
      this.getGeneratedContractUrl + '/' + contractId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProductionWrapUp(
    functionId: string,
    functionName: string
  ): Observable<WrapUp[]> {
    let params = new HttpParams().set('functionId', functionId);
    params = params.set('functionName', functionName);
    return this.http.get<WrapUp[]>(this.getProductionWrapUpUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getServiceWrapUp(
    functionId: string,
    functionName: string
  ): Observable<WrapUp[]> {
    let params = new HttpParams().set('functionId', functionId);
    params = params.set('functionName', functionName);
    return this.http.get<WrapUp[]>(this.getServiceWrapUpUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getChangeOrderById(changeOrderId: string): Observable<ChangeOrder[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('changeOrderId', changeOrderId);
    return this.http.get<ChangeOrder[]>(this.getChangeOrderByIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getChangeOrdersByProjectId(projectId: number): Observable<ChangeOrder[]> {
    return this.http.get<ChangeOrder[]>(
      this.getChangeOrdersByProjectIdUrl + '/' + projectId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getPermitById(permitId: string): Observable<Permit[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('permitId', permitId);
    return this.http.get<Permit[]>(this.getPermitByIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getPermitsByProjectId(projectId: number): Observable<Permit[]> {
    return this.http.get<Permit[]>(
      this.getPermitsByProjectIdUrl + '/' + projectId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getUtilitiesByProjectId(projectId: number): Observable<Utility[]> {
    return this.http.get<Utility[]>(
      this.getUtilitiesByProjectIdUrl + '/' + projectId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getSoldSheetByProposalId(proposalId: string): Observable<SoldSheet> {
    return this.http.get<SoldSheet>(
      this.getSoldSheetByProposalIdUrl + '/' + proposalId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getSalesCalendarEventByAppointmentId(
    appointmentId: number,
    company_code?: string
  ): Observable<SalesCalendarEvent> {
    let params = new HttpParams().set(
      'company_code',
      company_code ? company_code : this.localStorage.get('companyCode')
    );
    params = params.set('appointmentId', appointmentId);
    return this.http.get<SalesCalendarEvent>(
      this.getSalesCalendarEventByAppointmentIdUrl,
      { headers: this.accutraxAPIHeaders, params }
    );
  }

  getContractByProposalId(proposalId: string): Observable<Contract> {
    return this.http.get<Contract>(
      this.getContractByProposalIdUrl + '/' + proposalId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getGeneratedChangeOrderContract(
    changeOrderId: string
  ): Observable<GeneratedChangeOrderContract[]> {
    return this.http.get<GeneratedChangeOrderContract[]>(
      this.getGeneratedChangeOrderContractUrl + '/' + changeOrderId,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getJobAddressById(jobAddressId: number): Observable<JobAddress> {
    return this.http.get<JobAddress>(
      this.getJobAddressByIdUrl + '/' + jobAddressId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getJobAddressesByCustomerId(customerId: number): Observable<JobAddress[]> {
    return this.http.get<JobAddress[]>(
      this.getJobAddressesByCustomerIdUrl + '/' + customerId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getNeedsFirstContact(status: number): Observable<Project[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('status', status);
    return this.http.get<Project[]>(this.getNeedsFirstContactUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getCCLContactByStatus(status: number): Observable<CCLContact[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('status', status);
    return this.http.get<CCLContact[]>(this.getCCLContactByStatusUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  checkForCCLContact(projectId: number): Observable<CCLContact | null> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('projectId', projectId);
    return this.http.get<CCLContact | null>(this.checkForCCLContactUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getCCLContactProjects(jobAddressId: number): Observable<CCLContactProject[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('jobAddressId', jobAddressId);
    return this.http.get<CCLContactProject[]>(this.getCCLContactProjectsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getGeneratedUpsellContract(
    contractId: number
  ): Observable<GeneratedUpsellContract> {
    return this.http.get<GeneratedUpsellContract>(
      this.getGeneratedUpsellContractUrl + '/' + contractId,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getVariableConfig(): Observable<VariableConfig> {
    return this.http.get<VariableConfig>(
      this.getVariableConfigUrl + '/' + 'HTC',
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getContactMethodsByCustomerId(
    customerId: number
  ): Observable<ContactMethod[]> {
    return this.http.get<ContactMethod[]>(
      this.getContactMethodsByCustomerIdUrl + '/' + customerId,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getCustomerVisitById(customerVisitId: string): Observable<CustomerVisit> {
    return this.http.get<CustomerVisit>(
      this.getCustomerVisitByIdUrl + '/' + customerVisitId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getCustomerVisitsByJobAddressId(
    jobAddressId: number
  ): Observable<CustomerVisit[]> {
    return this.http.get<CustomerVisit[]>(
      this.getCustomerVisitsByJobAddressIdUrl + '/' + jobAddressId,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getProposalsByCustomerVisitId(
    customerVisitId: string
  ): Observable<Proposal[]> {
    return this.http.get<Proposal[]>(
      this.getProposalsByCustomerVisitIdUrl + '/' + customerVisitId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getCustomerVisitByAppointmentId(
    appointmentId: number
  ): Observable<CustomerVisit> {
    return this.http.get<CustomerVisit>(
      this.getCustomerVisitByAppointmentIdUrl + '/' + appointmentId,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getSpectrumInfo(projectId: number): Observable<SpectrumInfo> {
    let params = new HttpParams().set(
      'company_code',
      'HTC' // Keeping this hardcoded as 'HTC' instead of removing.
      // Accoording to Jim, Spectrum has to keep company code and we can't remove.
      // HTC will work for all companies
    );
    params = params.set('projectId', projectId);
    return this.http.get<SpectrumInfo>(this.getSpectrumInfoUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getCustomerVisitsSentToInsideSales(
    estimatorName: string
  ): Observable<CustomerVisit[]> {
    return this.http.get<CustomerVisit[]>(
      this.getCustomerVisitsSentToInsideSalesUrl + '/' + estimatorName,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getForemanZones(userId: string): Observable<Foreman[]> {
    return this.http.get<Foreman[]>(this.getForemanZonesUrl + '/' + userId, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getMailingRequestsByJobAddressId(
    jobAddressId: number
  ): Observable<MailingRequest[]> {
    return this.http.get<MailingRequest[]>(
      this.getMailingRequestsByJobAddressIdUrl + '/' + jobAddressId,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getMailingRequestsCount(): Observable<number> {
    return this.http.get<number>(this.getMailingRequestsCountUrl, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getOpenMailingRequests(): Observable<MailingRequest[]> {
    return this.http.get<MailingRequest[]>(this.getOpenMailingRequestsUrl, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getMailingRequestDocumentsByFunction(
    jobAddressId: number,
    functionId: string,
    functionName: string
  ) {
    let params = new HttpParams().set('jobAddressId', jobAddressId);
    params = params.set('functionId', functionId);
    params = params.set('functionName', functionName);
    return this.http.get<MailingRequestDocuments>(
      this.getMailingRequestDocumentsByFunctionUrl,
      { headers: this.accutraxAPIHeaders, params }
    );
  }

  getDrawingsByJobAddressId(jobAddressId: number): Observable<Drawing[]> {
    return this.http.get<Drawing[]>(
      this.getDrawingsByJobAddressIdUrl + '/' + jobAddressId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getNoteFunctionOptionsByJobAddressId(
    jobAddressId: number
  ): Observable<NoteFunctionOptions> {
    return this.http.get<NoteFunctionOptions>(
      this.getNoteFunctionOptionsByJobAddressIdUrl + '/' + jobAddressId,
      { headers: this.accutraxAPIHeaders }
    );
  }

  checkForExistingJobAddress(
    jobAddress: string,
    jobZip: number
  ): Observable<ExistingJobAddress[]> {
    let params = new HttpParams().set('jobAddress', jobAddress);
    params = params.set('jobZip', jobZip);
    return this.http.get<ExistingJobAddress[]>(
      this.checkForExistingJobAddressUrl,
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  getServiceAppointmentsByServiceProjectId(
    serviceProjectId: number
  ): Observable<ServiceAppointment[]> {
    return this.http.get<ServiceAppointment[]>(
      this.getServiceAppointmentsByServiceProjectIdUrl + '/' + serviceProjectId,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getEstimatorPriority(): Observable<EstimatorPriority[]> {
    return this.http.get<EstimatorPriority[]>(
      this.getEstimatorPriorityUrl + '/' + this.localStorage.get('companyCode'),
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getAllSpectrumCrewMembers(): Observable<SpectrumCrewMember[]> {
    return this.http.get<SpectrumCrewMember[]>(
      this.getAllSpectrumCrewMembersUrl,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getAllSpectrumMaterials(): Observable<SpectrumMaterial[]> {
    return this.http.get<SpectrumMaterial[]>(this.getAllSpectrumMaterialsUrl, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getProductionById(productionId: string): Observable<Production> {
    return this.http.get<Production>(
      this.getProductionByIdUrl + '/' + productionId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdDailiesByProductionId(productionId: string): Observable<ProdDaily[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('productionId', productionId);
    return this.http.get<ProdDaily[]>(this.getProdDailiesByProductionIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProdDailiesByJobAddressId(jobAddressId: number): Observable<ProdDaily[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('jobAddressId', jobAddressId);
    return this.http.get<ProdDaily[]>(this.getProdDailiesByJobAddressIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProdDailiesByContractId(contractId: number): Observable<ProdDaily[]> {
    return this.http.get<ProdDaily[]>(
      this.getProdDailiesByContractIdUrl + '/' + contractId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getContractById(contractId: number): Observable<Contract> {
    return this.http.get<Contract>(this.getContractByIdUrl + '/' + contractId, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getChangeOrdersByFunctionId(functionId: string): Observable<ChangeOrder[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('functionId', functionId);
    return this.http.get<ChangeOrder[]>(this.getChangeOrdersByFunctionIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getChangeOrdersByJobAddressId(
    jobAddressId: number
  ): Observable<ChangeOrder[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('jobAddressId', jobAddressId);
    return this.http.get<ChangeOrder[]>(this.getChangeOrdersByJobAddressIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getUpsellsByFunctionId(functionId: string): Observable<Upsell[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('functionId', functionId);
    return this.http.get<Upsell[]>(this.getUpsellsByFunctionIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProjectsByContractId(contractId: number): Observable<Project[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('contractId', contractId);
    return this.http.get<Project[]>(this.getProjectsByContractIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getInvoiceByProjectId(projectId: number): Observable<Invoice> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('projectId', projectId);
    return this.http.get<Invoice>(this.getInvoiceByProjectIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getInvoicesByFunctionId(functionId: string): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(
      this.getInvoicesByFunctionIdUrl + '/' + functionId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getBillingStatementsByFunctionId(
    functionId: string
  ): Observable<BillingStatement[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('functionId', functionId);
    return this.http.get<BillingStatement[]>(
      this.getBillingStatementsByFunctionIdUrl,
      { headers: this.accutraxAPIHeaders, params }
    );
  }

  getDailyPaymentInfo(productionId: string): Observable<DailyPaymentInfo> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('productionId', productionId);
    return this.http.get<DailyPaymentInfo>(
      this.getDailyPaymentInfoByProductionIdUrl,
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  getDailyPromptsByProductionId(
    productionId: string
  ): Observable<DailyPrompt[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('productionId', productionId);
    return this.http.get<DailyPrompt[]>(this.getDailyPromptsByProductionIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getGeneratedInvoiceByInvoiceNumber(
    invoiceNumber: string
  ): Observable<GeneratedInvoice | undefined> {
    return this.http.get<GeneratedInvoice | undefined>(
      this.getGeneratedInvoiceByInvoiceNumberUrl + '/' + invoiceNumber,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getDailyMaterialsByProductionId(
    productionId: string
  ): Observable<DailyMaterial[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('productionId', productionId);
    return this.http.get<DailyMaterial[]>(
      this.getDailyMaterialsByProductionIdUrl,
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  getCrewByProdDailyId(prodDailyId: string): Observable<Crew | undefined> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('prodDailyId', prodDailyId);
    return this.http.get<Crew | undefined>(this.getCrewByProdDailyIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getTimeLogsByProdDailyId(prodDailyId: string): Observable<TimeLog[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('prodDailyId', prodDailyId);
    return this.http.get<TimeLog[]>(this.getTimeLogsByProdDailyIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getTimeBreakDownByProdDailyId(
    prodDailyId: string
  ): Observable<TimeBreakDown> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('prodDailyId', prodDailyId);
    return this.http.get<TimeBreakDown>(this.getTimeBreakDownByProdDailyIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProjectsForProductionRecord(
    contractId: number,
    assignedName: string,
    productionCreatedDate: Date
  ): Observable<Project[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('contractId', contractId);
    params = params.set('assignedName', assignedName);
    params = params.set(
      'productionCreatedDate',
      productionCreatedDate.toString()
    );
    return this.http.get<Project[]>(this.getProjectsForProductionRecordUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getDailyPromptsByProdDailyId(prodDailyId: string): Observable<DailyPrompt[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('prodDailyId', prodDailyId);
    return this.http.get<DailyPrompt[]>(this.getDailyPromptsByProdDailyIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProductionJobDays(productionId: string): Observable<ProdAppointment[]> {
    return this.http.get<ProdAppointment[]>(
      this.getProductionJobDaysUrl + '/' + productionId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getZipcode(zipcode: number): Observable<Zipcode> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('zipcode', zipcode);
    return this.http.get<Zipcode>(this.getZipcodeUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getJobAddressesByZipcode(zipcode: number): Observable<JobAddress[]> {
    let params = new HttpParams().set('zipcode', zipcode);
    return this.http.get<JobAddress[]>(this.getJobAddressesByZipcodeUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getCommissionInfoByContractId(
    contractId: number
  ): Observable<CommissionInfo | null> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('contractId', contractId);
    return this.http.get<CommissionInfo | null>(
      this.getCommissionInfoByContractIdUrl,
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  getCommissionExceptionReasons(): Observable<CommissionExceptionReason[]> {
    return this.http.get<CommissionExceptionReason[]>(
      this.getCommissionExceptionReasonsUrl +
        '/' +
        this.localStorage.get('companyCode'),
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getUnlockedCommissions(
    company_code: string
  ): Observable<UnlockedCommission[]> {
    return this.http.get<UnlockedCommission[]>(
      this.getUnlockedCommissionsUrl + '/' + company_code,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getCommissionExceptionByContractId(
    contractId: number
  ): Observable<CommissionExceptions | null> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('contractId', contractId);
    return this.http.get<CommissionExceptions | null>(
      this.getCommissionExceptionByContractIdUrl,
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  checkIfUserCanReviewCommissions(userId: string): Observable<boolean> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('userId', userId);

    return this.http.get<boolean>(this.checkIfUserCanReviewCommissionsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  checkIfUserCanViewCommissions(userId: string): Observable<boolean> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('userId', userId);

    return this.http.get<boolean>(this.checkIfUserCanViewCommissionUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  recalculateMaxCommission(discount: number, estimator: string, inside: string, service: string, foreman: string): Observable<CommissionRecalculateResult> {
    let params = new HttpParams().set('discount', discount);
    params = params.set('estimator', estimator);
    params = params.set('inside', inside);
    params = params.set('service', service);
    params = params.set('foreman', foreman);

    return this.http.get<CommissionRecalculateResult>(this.recalculateMaxCommissionUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });

  }

  getSpectrumEmployees(lastName: string): Observable<SpectrumEmployees[]> {
    let params = new HttpParams().set('lastName', lastName);

    return this.http.get<SpectrumEmployees[]>(this.getSpectrumEmployeesUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getProductPricing(
    company_code: string,
    zoneId: number
  ): Observable<ProductPricing[]> {
    let params = new HttpParams().set('company_code', company_code);
    params = params.set('zoneId', zoneId);
    return this.http.get<ProductPricing[]>(this.getProductPricingUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getAllZipCodesByZip(zip: number): Observable<Zipcode[]> {
    return this.http.get<Zipcode[]>(this.getAllZipCodesByZipUrl + '/' + zip, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getAllCompanyCodes(): Observable<string[]> {
    return this.http.get<string[]>(this.getAllCompanyCodesUrl, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getInsideSalesProducts(
    company_code: string
  ): Observable<ProductSubCategory[]> {
    return this.http.get<ProductSubCategory[]>(
      this.getInsideSalesProductsUrl + '/' + company_code,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getInsideSalesStatements(): Observable<Statements[]> {
    return this.http.get<Statements[]>(
      this.getInsideSalesStatementsUrl +
        '/' +
        this.localStorage.get('companyCode'),
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getInsideSalesDispositions(): Observable<Disposition[]> {
    return this.http.get<Disposition[]>(
      this.getInsideSalesDispositionsUrl +
        '/' +
        this.localStorage.get('companyCode'),
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getInsideSalesSubDispositions(): Observable<SubDisposition[]> {
    return this.http.get<SubDisposition[]>(
      this.getInsideSalesSubDispositionsUrl +
        '/' +
        this.localStorage.get('companyCode'),
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getInsideSalesNoBidReasons(): Observable<NoBidReason[]> {
    return this.http.get<NoBidReason[]>(
      this.getInsideSalesNoBidReasonsUrl +
        '/' +
        this.localStorage.get('companyCode'),
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getEstimatorCompanyCodes(userId: string): Observable<string[]> {
    return this.http.get<string[]>(
      this.getEstimatorCompanyCodesUrl + '/' + userId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getEstimatorPriorityByUserId(
    userId: string
  ): Observable<EstimatorPriority[]> {
    return this.http.get<EstimatorPriority[]>(
      this.getEstimatorPriorityByUserIdUrl + '/' + userId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  checkUserRoleByEmail(email: string): Observable<string> {
    return this.http.get<string>(this.checkUserRoleByEmailUrl + '/' + email, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getDoNotCallByCustomerId(customerId: number): Observable<DoNotCall> {
    return this.http.get<DoNotCall>(
      this.getDoNotCallByCustomerIdUrl + '/' + customerId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getCalendarNotesByUserId(
    userId: string,
    date: string
  ): Observable<CalendarNote[]> {
    let params = new HttpParams().set('userId', userId);
    params = params.set('date', date);
    return this.http.get<CalendarNote[]>(this.getCalendarNotesByUserIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getCalendarNotesByNoteType(
    noteType: string,
    date: string
  ): Observable<CalendarNote[]> {
    let params = new HttpParams().set('noteType', noteType);
    params = params.set('date', date);
    return this.http.get<CalendarNote[]>(this.getCalendarNotesByNoteTypeUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  // PWA Gets
  getProdApptsByProjectId(projectId: number): Observable<ProdAppointment[]> {
    return this.http.get<ProdAppointment[]>(
      this.getProdApptsByProjectIdUrl + '/' + projectId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProductionWrapUpByProjectId(
    jobAddressId: number,
    projectId: number
  ): Observable<WrapUp[]> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('jobAddressId', jobAddressId);
    params = params.set('projectId', projectId);
    return this.http.get<WrapUp[]>(this.getProductionWrapUpByProjectIdUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  // Get PWA Attachments
  getPWAJobAddressIdsForAttachments(
    userid: string,
    functionName: string
  ): Observable<number[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('function', functionName);
    return this.http.get<number[]>(this.getPWAJobAddressIdsForAttachmentsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getPWAAttachmentsByJobAddressId(
    jobAddressId: number
  ): Observable<Attachment[]> {
    return this.http.get<Attachment[]>(
      this.getPWAAttachmentsByJobAddressIdUrl + '/' + jobAddressId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  // Get Offline Data. Sales
  getPWACustomers(
    userid: string,
    hotQuote: boolean = false
  ): Observable<Customer[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('hotQuote', hotQuote);
    return this.http.get<Customer[]>(this.getPWACustomersUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getPWALeads(userid: string, hotQuote: boolean = false): Observable<Lead[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('hotQuote', hotQuote);
    return this.http.get<Lead[]>(this.getPWALeadsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getPWAJobAddresses(
    userid: string,
    hotQuote: boolean = false
  ): Observable<JobAddress[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('hotQuote', hotQuote);
    return this.http.get<JobAddress[]>(this.getPWAJobAddressUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getPWAAppointments(
    userid: string,
    hotQuote: boolean = false
  ): Observable<Appointment[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('hotQuote', hotQuote);
    return this.http.get<Appointment[]>(this.getPWAAppointmentsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getPWASalesCalendar(
    userid: string,
    hotQuote: boolean = false
  ): Observable<SalesCalendarEvent[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('hotQuote', hotQuote);
    return this.http.get<SalesCalendarEvent[]>(this.getPWASalesCalendarUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getPWACustomerVisits(
    userid: string,
    hotQuote: boolean = false
  ): Observable<CustomerVisit[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('hotQuote', hotQuote);
    return this.http.get<CustomerVisit[]>(this.getPWACustomerVisitsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getPWAProposals(
    userid: string,
    hotQuote: boolean = false
  ): Observable<Proposal[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('hotQuote', hotQuote);
    return this.http.get<Proposal[]>(this.getPWAProposalsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getPWAProducts(
    userId: string,
    functionName: string
  ): Observable<ProductSubCategory[]> {
    let params = new HttpParams().set('userId', userId);
    params = params.set('functionName', functionName);

    return this.http.get<ProductSubCategory[]>(this.getPWAProductsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getPWAStatements(
    userId: string,
    functionName: string
  ): Observable<Statements[]> {
    let params = new HttpParams().set('userId', userId);
    params = params.set('functionName', functionName);

    return this.http.get<Statements[]>(this.getPWAStatementsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getPWAContracts(
    userid: string,
    hotQuote: boolean = false
  ): Observable<Contract[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('hotQuote', hotQuote);
    return this.http.get<Contract[]>(this.getPWAContractsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getPWAGeneratedContracts(
    userid: string,
    hotQuote: boolean = false
  ): Observable<GeneratedContract[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('hotQuote', hotQuote);
    return this.http.get<GeneratedContract[]>(
      this.getPWAGeneratedContractsUrl,
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  getPWANotes(userid: string, hotQuote: boolean = false): Observable<Note[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('hotQuote', hotQuote);
    return this.http.get<Note[]>(this.getPWANotesUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getPWASoldSheets(
    userid: string,
    hotQuote: boolean = false
  ): Observable<SoldSheet[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('hotQuote', hotQuote);
    return this.http.get<SoldSheet[]>(this.getPWASoldSheetsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getPWAAttachments(userid: string): Observable<Attachment[]> {
    return this.http.get<Attachment[]>(
      this.getPWAAttachmentsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getPWAFollowUps(
    userid: string,
    hotQuote: boolean = false
  ): Observable<FollowUp[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('hotQuote', hotQuote);
    return this.http.get<FollowUp[]>(this.getPWAFollowUpsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getSalesPWAContactMethods(
    userid: string,
    hotQuote: boolean = false
  ): Observable<ContactMethod[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('hotQuote', hotQuote);
    return this.http.get<ContactMethod[]>(this.getSalesPWAContactMethodsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  // Get Offline Data. Production
  getProdPWACustomers(userid: string): Observable<Customer[]> {
    return this.http.get<Customer[]>(
      this.getProdPWACustomersUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWAJobAddresses(userid: string): Observable<JobAddress[]> {
    return this.http.get<JobAddress[]>(
      this.getProdPWAJobAddressUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWAAppointments(userid: string): Observable<ProdAppointment[]> {
    return this.http.get<ProdAppointment[]>(
      this.getProdPWAAppointmentsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWAAvailability(userid: string): Observable<ProdAvailability[]> {
    return this.http.get<ProdAvailability[]>(
      this.getProdPWAAvailabilityUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWAGeneratedContracts(
    userid: string
  ): Observable<GeneratedContract[]> {
    return this.http.get<GeneratedContract[]>(
      this.getProdPWAGeneratedContractsUrl + '/' + userid,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getProdPWANotes(userid: string): Observable<Note[]> {
    return this.http.get<Note[]>(this.getProdPWANotesUrl + '/' + userid, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getProdPWAAttachments(userid: string): Observable<Attachment[]> {
    return this.http.get<Attachment[]>(
      this.getProdPWAAttachmentsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWAProjects(userid: string): Observable<Project[]> {
    return this.http.get<Project[]>(this.getProdPWAProjectsUrl + '/' + userid, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getProdPWAProduction(userid: string): Observable<Production[]> {
    return this.http.get<Production[]>(
      this.getProdPWAProductionUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  // getProdPWAProducts(userid: string): Observable<ProductSubCategory[]> {
  //   return this.http.get<ProductSubCategory[]>(
  //     this.getProdPWAProductsUrl + '/' + userid,
  //     {
  //       headers: this.accutraxAPIHeaders,
  //     }
  //   );
  // }

  // getProdPWAStatements(userid: string): Observable<Statements[]> {
  //   return this.http.get<Statements[]>(
  //     this.getProdPWAStatementsUrl + '/' + userid,
  //     {
  //       headers: this.accutraxAPIHeaders,
  //     }
  //   );
  // }

  getProdPWAProposals(userid: string): Observable<Proposal[]> {
    return this.http.get<Proposal[]>(
      this.getProdPWAProposalsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWAChangeOrders(userid: string): Observable<ChangeOrder[]> {
    return this.http.get<ChangeOrder[]>(
      this.getProdPWAChangeOrdersUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWAAccountingInfo(userid: string): Observable<AccountingInfo[]> {
    return this.http.get<AccountingInfo[]>(
      this.getProdPWAAccountingInfoUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWAContracts(userid: string): Observable<Contract[]> {
    return this.http.get<Contract[]>(
      this.getProdPWAContractsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWAChangeOrderContracts(
    userid: string
  ): Observable<ChangeOrderContract[]> {
    return this.http.get<ChangeOrderContract[]>(
      this.getProdPWAChangeOrderContractsUrl + '/' + userid,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getProdPWAGeneratedChangeOrderContracts(
    userid: string
  ): Observable<GeneratedChangeOrderContract[]> {
    return this.http.get<GeneratedChangeOrderContract[]>(
      this.getProdPWAGeneratedChangeOrderContractsUrl + '/' + userid,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getProdPWAInvoices(userid: string): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(this.getProdPWAInvoicesUrl + '/' + userid, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getProdPWAContactMethods(userid: string): Observable<ContactMethod[]> {
    return this.http.get<ContactMethod[]>(
      this.getProdPWAContactMethodsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWAProdDailies(userid: string): Observable<ProdDaily[]> {
    return this.http.get<ProdDaily[]>(
      this.getProdPWAProdDailiesUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWACrews(userid: string): Observable<Crew[]> {
    return this.http.get<Crew[]>(this.getProdPWACrewsUrl + '/' + userid, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getProdPWATimeLogs(userid: string): Observable<TimeLog[]> {
    return this.http.get<TimeLog[]>(this.getProdPWATimeLogsUrl + '/' + userid, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getProdPWATimeBreakDowns(userid: string): Observable<TimeBreakDown[]> {
    return this.http.get<TimeBreakDown[]>(
      this.getProdPWATimeBreakDownsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWADailyMaterials(userid: string): Observable<DailyMaterial[]> {
    return this.http.get<DailyMaterial[]>(
      this.getProdPWADailyMaterialsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWADailyPaymentInfo(userid: string): Observable<DailyPaymentInfo[]> {
    return this.http.get<DailyPaymentInfo[]>(
      this.getProdPWADailyPaymentInfoUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWADailyPrompts(userid: string): Observable<DailyPrompt[]> {
    return this.http.get<DailyPrompt[]>(
      this.getProdPWADailyPromptsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWAUpsells(userid: string): Observable<Upsell[]> {
    return this.http.get<Upsell[]>(this.getProdPWAUpsellsUrl + '/' + userid, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getProdPWAUpsellContracts(userid: string): Observable<UpsellContract[]> {
    return this.http.get<UpsellContract[]>(
      this.getProdPWAUpsellContractsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWAGeneratedUpsellContracts(
    userid: string
  ): Observable<GeneratedUpsellContract[]> {
    return this.http.get<GeneratedUpsellContract[]>(
      this.getProdPWAGeneratedUpsellContractsUrl + '/' + userid,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getProdPWAGeneratedInvoices(userid: string): Observable<GeneratedInvoice[]> {
    return this.http.get<GeneratedInvoice[]>(
      this.getProdPWAGeneratedInvoicesUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWABillingStatements(userid: string): Observable<BillingStatement[]> {
    return this.http.get<BillingStatement[]>(
      this.getProdPWABillingStatementsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getProdPWALeads(userid: string): Observable<Lead[]> {
    return this.http.get<Lead[]>(this.getProdPWALeadsUrl + '/' + userid, {
      headers: this.accutraxAPIHeaders,
    });
  }

  // Get Offline Data. Service
  getServicePWACustomers(userid: string): Observable<Customer[]> {
    return this.http.get<Customer[]>(
      this.getServicePWACustomersUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getServicePWAJobAddresses(userid: string): Observable<JobAddress[]> {
    return this.http.get<JobAddress[]>(
      this.getServicePWAJobAddressUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getServicePWAAppointments(userid: string): Observable<ServiceAppointment[]> {
    return this.http.get<ServiceAppointment[]>(
      this.getServicePWAAppointmentsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getServicePWAAvailability(userid: string): Observable<ServiceAvailability[]> {
    return this.http.get<ServiceAvailability[]>(
      this.getServicePWAAvailabilityUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  // getServicePWAProducts(userid: string): Observable<ProductSubCategory[]> {
  //   return this.http.get<ProductSubCategory[]>(
  //     this.getServicePWAProductsUrl + '/' + userid,
  //     {
  //       headers: this.accutraxAPIHeaders,
  //     }
  //   );
  // }

  // getServicePWAStatements(userid: string): Observable<Statements[]> {
  //   return this.http.get<Statements[]>(
  //     this.getServicePWAStatementsUrl + '/' + userid,
  //     {
  //       headers: this.accutraxAPIHeaders,
  //     }
  //   );
  // }

  getServicePWAGeneratedContracts(
    userid: string
  ): Observable<GeneratedContract[]> {
    return this.http.get<GeneratedContract[]>(
      this.getServicePWAGeneratedContractsUrl + '/' + userid,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getServicePWAServiceProjects(userid: string): Observable<ServiceProject[]> {
    return this.http.get<ServiceProject[]>(
      this.getServicePWAServiceProjectsUrl + '/' + userid,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getServicePWANotes(userid: string): Observable<Note[]> {
    return this.http.get<Note[]>(this.getServicePWANotesUrl + '/' + userid, {
      headers: this.accutraxAPIHeaders,
    });
  }

  getServicePWAAttachments(userid: string): Observable<Attachment[]> {
    return this.http.get<Attachment[]>(
      this.getServicePWAAttachmentsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getServicePWAVisits(userid: string): Observable<ServiceVisit[]> {
    return this.http.get<ServiceVisit[]>(
      this.getServicePWAVisitsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getServicePWAProposals(userid: string): Observable<Proposal[]> {
    return this.http.get<Proposal[]>(
      this.getServicePWAProposalsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getServicePWAProdProjects(userid: string): Observable<Project[]> {
    return this.http.get<Project[]>(
      this.getServicePWAProdProjectsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getServicePWAContactMethods(userid: string): Observable<ContactMethod[]> {
    return this.http.get<ContactMethod[]>(
      this.getServicePWAContactMethodsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getServicePWASoldSheets(userid: string): Observable<SoldSheet[]> {
    return this.http.get<SoldSheet[]>(
      this.getServicePWASoldSheetsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getServicePWAContracts(userid: string): Observable<Contract[]> {
    return this.http.get<Contract[]>(
      this.getServicePWAContractsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getServicePWAWrapUps(userid: string): Observable<WrapUp[]> {
    return this.http.get<WrapUp[]>(
      this.getServicePWAProdWrapUpsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getServicePWAProdVisits(userid: string): Observable<Production[]> {
    return this.http.get<Production[]>(
      this.getServicePWAProdVisitsUrl + '/' + userid,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getServicePWAUpsellContracts(userid: string): Observable<UpsellContract[]> {
    return this.http.get<UpsellContract[]>(
      this.getServicePWAUpsellContractsUrl + '/' + userid,
      { headers: this.accutraxAPIHeaders }
    );
  }

  getServicePWAGeneratedUpsellContracts(
    userid: string
  ): Observable<GeneratedUpsellContract[]> {
    return this.http.get<GeneratedUpsellContract[]>(
      this.getServicePWAGeneratedUpsellContractsUrl + '/' + userid,
      { headers: this.accutraxAPIHeaders }
    );
  }

  //#endregion

  // PWA Shared
  getPWACalendarNotes(
    userid: string,
    functionName: string
  ): Observable<CalendarNote[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('function', functionName);
    return this.http.get<CalendarNote[]>(this.getPWACalendarNotesUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  postPWACalendarNote(calendarNote: CalendarNote): Observable<void> {
    return this.http.post<void>(this.postPWACalendarNoteUrl, calendarNote, {
      headers: this.accutraxAPIHeaders,
    });
  }

  LogPWAJsonBackUp(
    pwaLog: PWAModel,
    userId: string,
    userName: string,
    loggedDate: Date | string,
    functionName: string
  ): Observable<PWAModel> {
    let params = new HttpParams().set('userId', userId);
    params = params.set('userName', userName);
    params = params.set('loggedDate', loggedDate.toString());
    params = params.set('functionName', functionName);

    return this.http.post<PWAModel>(this.logPWAJsonBackUpUrl, pwaLog, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getPWAMailingRequests(
    userid: string,
    functionName: string,
    hotQuote: boolean = false
  ): Observable<MailingRequest[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('functionName', functionName);
    params = params.set('hotQuote', hotQuote);
    return this.http.get<MailingRequest[]>(this.getPWAMailingRequestsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  getPWADrawings(
    userid: string,
    functionName: string,
    hotQuote: boolean = false
  ): Observable<Drawing[]> {
    let params = new HttpParams().set('userid', userid);
    params = params.set('functionName', functionName);
    params = params.set('hotQuote', hotQuote);
    return this.http.get<Drawing[]>(this.getPWADrawingsUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  postOfflineUserSyncDownLog(
    offlineUserSyncDownLog: OfflineUserSyncDownLog
  ): Observable<void> {
    return this.http.post<void>(
      this.postOfflineUserSyncDownLogUrl,
      offlineUserSyncDownLog,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getPWAProductPricing(
    userId: string,
    functionName: string
  ): Observable<ProductPricing[]> {
    let params = new HttpParams().set('userId', userId);
    params = params.set('functionName', functionName);
    return this.http.get<ProductPricing[]>(this.getPWAProductPricingUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  //#region POST
  createCustomer(customerObject: Customer): Observable<number> {
    return this.http.post<number>(this.insertCustomerUrl, customerObject, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createJobAddress(jobAddressObject: JobAddress): Observable<number> {
    return this.http.post<number>(this.insertJobAddressUrl, jobAddressObject, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createLead(leadObject: Lead): Observable<number> {
    return this.http.post<number>(this.insertLeadUrl, leadObject, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createAppointment(appointmentObject: Appointment): Observable<number> {
    return this.http.post<number>(
      this.insertAppointmentUrl,
      appointmentObject,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  createUser(userObject: User): Observable<void> {
    return this.http.post<void>(this.insertUserUrl, userObject, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createEstimatorAvailability(
    estimatorAvailabilityObject: EstimatorAvailability
  ): Observable<void> {
    return this.http.post<void>(
      this.insertEstimatorAvailabilityUrl,
      estimatorAvailabilityObject,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  createNote(noteObject: Note): Observable<void> {
    return this.http.post<void>(this.insertNoteUrl, noteObject, {
      headers: this.accutraxAPIHeaders,
    });
  }

  // createProposal(proposalDetailsObject: Proposal): Observable<void> {
  //   return this.http.post<void>(this.insertProposalUrl, proposalDetailsObject);
  // }

  // Not used
  createCustomerVisit(customerVisitObject: CustomerVisit): Observable<number> {
    return this.http.post<number>(
      this.insertCustomerVisitUrl,
      customerVisitObject,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  createContract(contract: Contract): Observable<number> {
    return this.http.post<number>(this.insertContractUrl, contract, {
      headers: this.accutraxAPIHeaders,
    });
  }

  // Not used
  // createCustomerVisitFollowUp(followUp: FollowUp): Observable<void> {
  //   return this.http.post<void>(this.insertCustomerVisitFollowUpUrl, followUp);
  // }

  createProjects(proposalId: string, status: number): Observable<void> {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('proposalId', proposalId);
    params = params.set('status', status);
    return this.http.post<void>(
      this.projectPostUrl,
      {},
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  createProdAppointment(prodAppointment: ProdAppointment): Observable<void> {
    return this.http.post<void>(
      this.insertProdAppointmentUrl,
      prodAppointment,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  // Prod Visit
  // createProduction(productionObject: FullProduction): Observable<number> {
  //   return this.http.post<number>(this.insertProductionUrl, productionObject);
  // }

  createChangeOrder(changeOrder: ChangeOrder): Observable<void> {
    return this.http.post<void>(this.insertChangeOrderUrl, changeOrder, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createUpsell(upsell: Upsell): Observable<void> {
    return this.http.post<void>(this.insertUpsellUrl, upsell, {
      headers: this.accutraxAPIHeaders,
    });
  }

  // Service Visit & Schedule
  createServiceAppointment(
    serviceAppointment: ServiceAppointment
  ): Observable<void> {
    return this.http.post<void>(
      this.insertServiceAppointmentUrl,
      serviceAppointment,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  createServiceCall(serviceCall: ServiceProject): Observable<number> {
    return this.http.post<number>(this.insertServiceCallUrl, serviceCall, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createServiceProject(
    serviceProject: ServiceProject,
    serviceCallId: number
  ): Observable<void> {
    return this.http.post<void>(this.insertServiceProjectUrl, serviceProject, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createServiceVisit(serviceVisit: ServiceVisit): Observable<number> {
    return this.http.post<number>(this.insertServiceVisitUrl, serviceVisit, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createGeneratedContract(
    generatedContract: GeneratedContract
  ): Observable<void> {
    return this.http.post<void>(
      this.postGeneratedContractUrl,
      generatedContract,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  createProductionWrapUp(wrapUp: WrapUp): Observable<void> {
    return this.http.post<void>(this.insertProductionWrapUpUrl, wrapUp, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createServiceWrapUp(wrapUp: WrapUp): Observable<void> {
    return this.http.post<void>(this.insertServiceWrapUpUrl, wrapUp, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createSoldSheet(soldSheet: SoldSheet): Observable<void> {
    return this.http.post<void>(this.insertSoldSheetUrl, soldSheet, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createPermit(permit: Permit): Observable<void> {
    return this.http.post<void>(this.insertPermitUrl, permit, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createUtility(utility: Utility): Observable<void> {
    return this.http.post<void>(this.insertUtilityUrl, utility, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createCalendarNote(calendarNote: CalendarNote): Observable<number> {
    return this.http.post<number>(this.insertCalendarNoteUrl, calendarNote, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createCCLContact(cclContact: CCLContact): Observable<number> {
    return this.http.post<number>(this.insertCCLContactUrl, cclContact, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createChangeOrderContract(
    changeOrderContract: ChangeOrderContract
  ): Observable<number> {
    return this.http.post<number>(
      this.insertChangeOrderContractUrl,
      changeOrderContract,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  createGeneratedChangeOrderContract(
    generatedChangeOrderContract: GeneratedChangeOrderContract
  ): Observable<number> {
    return this.http.post<number>(
      this.insertGeneratedChangeOrderContractUrl,
      generatedChangeOrderContract,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  createContactMethod(contactMethod: ContactMethod): Observable<void> {
    return this.http.post<void>(this.insertContactMethodUrl, contactMethod, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createProposal(proposal: Proposal): Observable<void> {
    return this.http.post<void>(this.insertProposalUrl, proposal, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createFollowUp(followUp: FollowUp): Observable<void> {
    return this.http.post<void>(this.insertFollowUpUrl, followUp, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createInsideSalesContract(insideSalesContract: Contract): Observable<number> {
    return this.http.post<number>(
      this.insertInsideSalesContractUrl,
      insideSalesContract,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  createInsideSalesGeneratedContract(
    insideSalesGeneratedContract: GeneratedContract
  ): Observable<number> {
    return this.http.post<number>(
      this.insertInsideSalesGeneratedContractUrl,
      insideSalesGeneratedContract,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  createInsideSalesSoldSheet(
    insideSalesSoldSheet: SoldSheet
  ): Observable<void> {
    return this.http.post<void>(
      this.insertInsideSalesSoldSheetUrl,
      insideSalesSoldSheet,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  createForemanZone(foreman: Foreman): Observable<void> {
    return this.http.post<void>(this.insertForemanZoneUrl, foreman, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createMailingRequests(mailingRequests: MailingRequest): Observable<void> {
    return this.http.post<void>(
      this.insertMailingRequestsUrl,
      mailingRequests,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  createDrawing(drawing: Drawing): Observable<void> {
    return this.http.post<void>(this.insertDrawingUrl, drawing, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createInvoice(invoice: Invoice): Observable<void> {
    return this.http.post<void>(this.insertInvoiceUrl, invoice, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createGeneratedInvoice(generatedInvoice: GeneratedInvoice): Observable<void> {
    return this.http.post<void>(
      this.insertGeneratedInvoiceUrl,
      generatedInvoice,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  createBillingStatement(billingStatement: BillingStatement): Observable<void> {
    return this.http.post<void>(
      this.insertBillingStatementUrl,
      billingStatement,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  createDailyMaterial(dailyMaterial: DailyMaterial): Observable<void> {
    return this.http.post<void>(this.insertDailyMaterialUrl, dailyMaterial, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createDailyPaymentInfo(dailyPaymentInfo: DailyPaymentInfo): Observable<void> {
    return this.http.post<void>(
      this.insertDailyPaymentInfoUrl,
      dailyPaymentInfo,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  createCrew(crew: Crew): Observable<void> {
    return this.http.post<void>(this.insertCrewUrl, crew, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createTimeLog(timeLog: TimeLog): Observable<void> {
    return this.http.post<void>(this.insertTimeLogUrl, timeLog, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createTimeBreakDown(timeBreakDown: TimeBreakDown): Observable<void> {
    return this.http.post<void>(this.insertTimeBreakDownUrl, timeBreakDown, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createDailyPrompt(dailyPrompt: DailyPrompt): Observable<void> {
    return this.http.post<void>(this.insertDailyPromptUrl, dailyPrompt, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createProdDaily(prodDaily: ProdDaily): Observable<void> {
    return this.http.post<void>(this.insertProdDailyUrl, prodDaily, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createEstimatorPriority(
    estimatorPriority: EstimatorPriority
  ): Observable<void> {
    return this.http.post<void>(
      this.insertEstimatorPriorityUrl,
      estimatorPriority,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  createZipcode(zipcode: Zipcode): Observable<void> {
    return this.http.post<void>(this.insertZipcodeUrl, zipcode, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createCommissionInfo(commissionInfo: CommissionInfo): Observable<void> {
    return this.http.post<void>(this.insertCommissionInfoUrl, commissionInfo, {
      headers: this.accutraxAPIHeaders,
    });
  }

  createCommissionException(
    CommissionException: CommissionExceptions
  ): Observable<void> {
    return this.http.post<void>(
      this.insertCommissionExceptionUrl,
      CommissionException,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  createDoNotCall(doNotCall: DoNotCall): Observable<void> {
    return this.http.post<void>(this.insertDoNotCallUrl, doNotCall, {
      headers: this.accutraxAPIHeaders,
    });
  }

  // PWA Posts

  postSalesPWAData(pwaData: PWAModel): Observable<string> {
    return this.http.post<string>(this.insertSalesPWADataUrl, pwaData, {
      headers: this.accutraxAPIHeaders,
    });
  }

  postProdPWAData(pwaData: PWAModel): Observable<string> {
    return this.http.post<string>(this.insertProdPWADataUrl, pwaData, {
      headers: this.accutraxAPIHeaders,
    });
  }

  postServicePWAData(pwaData: PWAModel): Observable<string> {
    return this.http.post<string>(this.insertServicePWADataUrl, pwaData, {
      headers: this.accutraxAPIHeaders,
    });
  }

  // Not used
  // postPWAAttachments(attachments: Attachment[]): Observable<string> {
  //   return this.http.post<string>(this.insertPWAAttachmentsUrl, attachments);
  // }

  //#endregion

  //#region PUT
  updateCustomer(customerObject: Customer) {
    return this.http.put<Customer>(this.updateCustomerUrl, customerObject, {
      headers: this.accutraxAPIHeaders,
    });
  }

  updateLead(leadObject: Lead) {
    return this.http.put<Lead>(this.updateLeadUrl, leadObject, {
      headers: this.accutraxAPIHeaders,
    });
  }

  updateCustomerVisit(customerVisitObject: CustomerVisit) {
    return this.http.put<CustomerVisit>(
      this.updateCustomerVisitUrl,
      customerVisitObject,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  updateProposal(
    proposalId: string,
    status: number,
    statusName: string,
    IsGenerated: boolean,
    customerVisitId: string,
    proposal: Proposal
  ) {
    let params = new HttpParams().set('proposalId', proposalId);
    params = params.set('status', status);
    params = params.set('proposalStatusName', statusName);
    params = params.set('IsGenerated', IsGenerated);
    params = params.set('customervisitId', customerVisitId);
    return this.http.put(this.updateProposalUrl, proposal, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  updateContract(contract: Contract) {
    return this.http.put<Contract>(this.updateContractUrl, contract, {
      headers: this.accutraxAPIHeaders,
    });
  }

  updateUser(user: User) {
    return this.http.put<User>(this.updateUserUrl, user, {
      headers: this.accutraxAPIHeaders,
    });
  }

  updateAppointment(appointment: Appointment) {
    return this.http.put<Appointment>(this.updateAppointmentUrl, appointment, {
      headers: this.accutraxAPIHeaders,
    });
  }

  updateProjectRequirements(
    projectId: number,
    needsPermit: boolean,
    needsUtilities: boolean
  ) {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('projectid', projectId.toString());
    params = params.set('needsPermit', needsPermit.toString());
    params = params.set('needsUtilities', needsUtilities.toString());
    return this.http.put(
      this.updateProjectRequirementsUrl,
      {},
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  updatePermit(permit: Permit) {
    return this.http.put<Permit>(this.updatePermitUrl, permit, {
      headers: this.accutraxAPIHeaders,
    });
  }

  updateUtility(utility: Utility) {
    return this.http.put<Utility>(this.updateUtilityUrl, utility, {
      headers: this.accutraxAPIHeaders,
    });
  }

  updateCalendarNote(calendarNote: CalendarNote) {
    return this.http.put<CalendarNote>(
      this.updateCalendarNoteUrl,
      calendarNote,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  rescheduleProdAppointment(
    prodSchedId: number,
    startTimeUTC: string,
    endTimeUTC: string,
    updatedBy: string,
    projectId: number
  ) {
    let params = new HttpParams().set('prodSchedId', prodSchedId.toString());
    params = params.set('startTimeUTC', startTimeUTC);
    params = params.set('endTimeUTC', endTimeUTC);
    params = params.set('updatedBy', updatedBy);
    params = params.set('projectId', projectId.toString());
    return this.http.put(
      this.updateProdAppointmentUrl,
      {},
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  rescheduleServAppointment(
    servAppointmentId: number,
    startTimeUTC: string,
    endTimeUTC: string,
    updatedBy: string
  ) {
    let params = new HttpParams().set(
      'servAppointmentId',
      servAppointmentId.toString()
    );
    params = params.set('startTimeUTC', startTimeUTC);
    params = params.set('endTimeUTC', endTimeUTC);
    params = params.set('updatedBy', updatedBy);
    return this.http.put(
      this.updateServAppointmentUrl,
      {},
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  updateSalesManagerNotes(contractId: number, salesManagerNotes: string) {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('contractId', contractId);
    params = params.set('salesManagerNotes', salesManagerNotes);
    return this.http.put(
      this.updateSalesManagerNotesUrl,
      {},
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  updateJobAddress(jobAddressObject: JobAddress) {
    return this.http.put<JobAddress>(
      this.updateJobAddressUrl,
      jobAddressObject,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  updateCCLContact(cclContact: CCLContact) {
    return this.http.put<CCLContact>(this.updateCCLContactUrl, cclContact, {
      headers: this.accutraxAPIHeaders,
    });
  }

  updateAttachmentLabel(attachment: Attachment) {
    return this.http.put<Attachment>(
      this.updateAttachmentLabelUrl,
      attachment,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  updateChangeOrderContract(changeOrderContract: ChangeOrderContract) {
    return this.http.put<ChangeOrderContract>(
      this.updateChangeOrderContractUrl,
      changeOrderContract,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  updateGeneratedChangeOrderContract(
    generatedChangeOrderContract: GeneratedChangeOrderContract
  ) {
    return this.http.put<GeneratedChangeOrderContract>(
      this.updateGeneratedChangeOrderContractUrl,
      generatedChangeOrderContract,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  approveChangeOrder(
    changeOrderId: string,
    approvedById: string,
    approvedByName: string
  ) {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('changeOrderId', changeOrderId);
    params = params.set('approvedById', approvedById);
    params = params.set('approvedByName', approvedByName);
    return this.http.put(
      this.approveChangeOrderUrl,
      {},
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  updateInsideSalesProposal(proposal: Proposal) {
    return this.http.put<Proposal>(
      this.updateInsideSalesProposalUrl,
      proposal,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  updateContactMethod(contactMethod: ContactMethod) {
    return this.http.put<ContactMethod>(
      this.updateContactMethodUrl,
      contactMethod,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  updateGeneratedContract(generatedContract: GeneratedContract) {
    return this.http.put<GeneratedContract>(
      this.updateGeneratedContractUrl,
      generatedContract,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  updateMailingRequest(mailingRequest: MailingRequest) {
    return this.http.put<MailingRequest>(
      this.updateMailingRequestUrl,
      mailingRequest,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  updateDrawing(drawing: Drawing) {
    return this.http.put<Drawing>(this.updateDrawingUrl, drawing, {
      headers: this.accutraxAPIHeaders,
    });
  }

  updateProjectNotes(projectId: number, projectNotes: string) {
    let params = new HttpParams().set('projectId', projectId);
    params = params.set('projectNotes', projectNotes);
    return this.http.put(
      this.updateProjectNotesUrl,
      {},
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  updateServiceProjectNotes(serviceProjectId: number, projectNotes: string) {
    let params = new HttpParams().set('serviceProjectId', serviceProjectId);
    params = params.set('projectNotes', projectNotes);
    return this.http.put(
      this.updateServiceProjectNotesUrl,
      {},
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  updateEstimatorPriority(estimatorPriority: EstimatorPriority) {
    return this.http.put<EstimatorPriority>(
      this.updateEstimatorPriorityUrl,
      estimatorPriority,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  updateProject(project: Project) {
    return this.http.put<Project>(this.updateProjectUrl, project, {
      headers: this.accutraxAPIHeaders,
    });
  }

  updateProdDaily(prodDaily: ProdDaily) {
    return this.http.put<ProdDaily>(this.updateProdDailyUrl, prodDaily, {
      headers: this.accutraxAPIHeaders,
    });
  }

  updateDailyMaterial(dailyMaterial: DailyMaterial) {
    return this.http.put<DailyMaterial>(
      this.updateDailyMaterialUrl,
      dailyMaterial,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  updateLeadZone(
    leadId: number,
    zip: number,
    zoneid: number,
    zoneName: string,
    geoZoneId: number,
    geoZoneName: string
  ) {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('leadId', leadId.toString());
    params = params.set('zip', zip.toString());
    params = params.set('zoneid', zoneid.toString());
    params = params.set('zoneName', zoneName);
    params = params.set('geoZoneId', geoZoneId.toString());
    params = params.set('geoZoneName', geoZoneName);
    return this.http.put(
      this.updateLeadZoneUrl,
      {},
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  cancelProject(
    projectId: number,
    cancellationReason: string,
    userId: string,
    userName: string
  ) {
    let params = new HttpParams().set('projectId', projectId.toString());
    params = params.set('cancellationReason', cancellationReason);
    params = params.set('userId', userId);
    params = params.set('userName', userName);
    return this.http.put(
      this.cancelProjectUrl,
      {},
      {
        headers: this.accutraxAPIHeaders,
        params,
      }
    );
  }

  // Prod Visit
  updateProduction(productionObject: Production) {
    return this.http.put<Production>(
      this.updateProductionUrl,
      productionObject,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  // Service Call
  updateServiceProject(serviceProject: ServiceProject) {
    return this.http.put<ServiceProject>(
      this.updateServiceProjectUrl,
      serviceProject,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  updateServiceVisit(serviceVisit: ServiceVisit) {
    return this.http.put<ServiceVisit>(
      this.updateServiceVisitUrl,
      serviceVisit,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  updateDailyPaymentInfo(dailyPaymentInfo: DailyPaymentInfo) {
    return this.http.put<DailyPaymentInfo>(
      this.updateDailyPaymentInfoUrl,
      dailyPaymentInfo,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  //#endregion

  //#region DELETE
  deleteEstimatorAvailability(uniqueId: string) {
    return this.http.delete<void>(
      this.deleteEstimatorAvailabilityUrl + '/' + uniqueId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  deleteProdAppointment(prodSchedId: number, projectId: number) {
    let params = new HttpParams().set('prodschedId', prodSchedId);
    params = params.set('projectid', projectId);
    return this.http.delete<void>(this.deleteProdAppointmentUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  deleteServiceAppointment(servAppointmentId: number, serviceId: number) {
    let params = new HttpParams().set('servAppointmentId', servAppointmentId);
    params = params.set('serviceId', serviceId);
    return this.http.delete<void>(this.deleteServiceAppointmentUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  deleteSalesAppointment(appointmentId: number, leadId: number) {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('appointmentId', appointmentId);
    params = params.set('leadId', leadId);
    return this.http.delete<void>(this.deleteSalesAppointmentUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  deletePermit(permitId: number) {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('permitId', permitId);
    return this.http.delete<void>(this.deletePermitUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  deleteUtility(utilityId: number) {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('utilityId', utilityId);
    return this.http.delete<void>(this.deleteUtilityUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  deleteCalendarNote(noteId: number) {
    return this.http.delete<void>(this.deleteCalendarNoteUrl + '/' + noteId, {
      headers: this.accutraxAPIHeaders,
    });
  }

  deleteContactMethod(contactMethodId: number) {
    return this.http.delete<void>(
      this.deleteContactMethodUrl + '/' + contactMethodId,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  deleteProposal(proposalId: string) {
    return this.http.delete<void>(this.deleteProposalUrl + '/' + proposalId, {
      headers: this.accutraxAPIHeaders,
    });
  }

  deleteDrawing(drawingId: string) {
    return this.http.delete<void>(this.deleteDrawingUrl + '/' + drawingId, {
      headers: this.accutraxAPIHeaders,
    });
  }

  deleteChangeOrder(changeOrderId: string) {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('changeOrderId', changeOrderId);
    return this.http.delete<void>(this.deleteChangeOrderUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  deleteDailyMaterial(dailyMaterialId: string) {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('dailyMaterialId', dailyMaterialId);
    return this.http.delete<void>(this.deleteDailyMaterialUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  deleteTimeLog(timeLogId: string) {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('timeLogId', timeLogId);
    return this.http.delete<void>(this.deleteTimeLogUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  deleteTimeBreakDown(timeBreakDownId: string) {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('timeBreakDownId', timeBreakDownId);
    return this.http.delete<void>(this.deleteTimeBreakDownUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  deleteInvoice(projectId: number) {
    let params = new HttpParams().set(
      'company_code',
      this.localStorage.get('companyCode')
    );
    params = params.set('projectId', projectId);
    return this.http.delete<void>(this.deleteInvoiceUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }

  deleteForemanZones(userId: string) {
    return this.http.delete<void>(this.deleteForemanZonesUrl + '/' + userId, {
      headers: this.accutraxAPIHeaders,
    });
  }
  //#endregion

  //#region Google Maps
  geoCodeAddress(address: string): Observable<GeocodingResponse> {
    return this.http.get<GeocodingResponse>(
      this.geoCodeAddressUrl + '/' + address,
      {
        headers: this.accutraxAPIHeaders,
      }
    );
  }

  getTimeZone(
    lat: number,
    lng: number,
    timestamp: number
  ): Observable<TimeZoneResponse> {
    let params = new HttpParams().set('lat', lat.toString());
    params = params.set('lng', lng.toString());
    params = params.set('timestamp', timestamp.toString());
    return this.http.get<TimeZoneResponse>(this.getTimeZoneUrl, {
      headers: this.accutraxAPIHeaders,
      params,
    });
  }
  //#endregion
}
